  <!-- Preloader -->
  <!-- <div class="preloader">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="lds-hourglass"></div>
      </div>
    </div>
  </div> -->
  <!-- End Preloader -->

  <!-- Nabvar Area -->
  <nav class="navbar fixed-top navbar-expand-lg main-navbar bg-white">
    <div class="container">
      <a class="navbar-brand" href="http://oliu.io">
        <img src="assets/images/logo.png" alt="logo">
      </a>

      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="icon-bar top-bar"></span>
        <span class="icon-bar middle-bar"></span>
        <span class="icon-bar bottom-bar"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav m-auto">
          <li class="nav-item">
            <a class="nav-link" href="#home">Trang chủ</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#services">Sản phẩm</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#features">Tính năng</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#pricing">Bảng giá</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#contact">Liên hệ</a>
          </li>
        </ul>
        <div class="nav-btn">
          <a href="tel:0911998099" class="default-btn bg-main mr-2"> <i class="las la-phone bg-2"></i> 0911 998 099</a>
          <a href="#SignUpModal" class="default-btn bg-color" data-toggle="modal" data-target="#SignUpModal">Dùng thử
            ngay</a>
        </div>
      </div>
    </div>
  </nav>
  <!-- End Nabvar Area -->

  <!-- Sign Up Modal -->
  <div class="modal custom-modal fade" id="SignUpModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content" style="max-width:740px ;  max-height: 650px; overflow-y: scroll;">
        <div class="modal-header">
          <h5 class="modal-title">Đăng ký</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="user-form">
            <form id="form-register" [formGroup]="myForm">
              <div class="row">
                <div class="col-lg-12 col-sm-12">
                  <div class="form-group">
                    <select class="form-control cls-text-input" formControlName="idfield" (change)="name.focus()">
                      <option value="null">Chọn mô hình</option>
                      <option value="2">Phòng khám Đa khoa</option>
                      <option value="10">Phòng khám Da liễu</option>
                      <option value="12">Phòng khám Nhi</option>
                      <option value="13">Phòng khám Sản</option>
                      <option value="14">Phòng khám Mắt</option>
                      <option value="15">Phòng khám Đông y</option>
                      <option value="10">Phòng khám Nha Khoa</option>
                      <option value="4">Thẩm mỹ viện</option>
                      <option value="5">Spa</option>
                      <option value="3">Nhà thuốc</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-sm-12">
                  <div class="form-group">
                    <input #name type="text" class="form-control cls-text-input" placeholder="Tên cơ sở của bạn"
                      formControlName="name" name="name" (keydown.enter)="address.focus()">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-sm-12">
                  <div class="form-group">
                    <input #address name="address" placeholder="Địa chỉ cơ sở của bạn" type="text"
                      formControlName="address" class="form-control cls-text-input"
                      (keydown.enter)="uniquename.focus()">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-9 col-sm-9" style="padding-right: 0px;">
                  <div class="form-group">
                    <input #uniquename name="subdomain" placeholder="Tên miền địa chỉ mong muốn của bạn" type="text"
                      class="form-control cls-text-input" required minlength="4" maxlength="30"
                      formControlName="uniquename" (keyup)="setUniquename($event.target.value)"
                      (keydown.enter)="namecreate.focus()">
                  </div>
                </div>
                <div class="col-lg-3 col-sm-3" style="padding-left: 0px; ">
                  <div class="form-group">
                    <span style="padding-top: 5px;">
                      <input type="text" class="form-control cls-text-input" style="font-family: 'RobotoBold';font-weight: bold;
                                                      font-size: 24px; background-color: #f5f5f5;border-left:0px;"
                        placeholder=".oliu.io" readonly="true">
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-sm-12">
                  <div class="form-group">
                    <input #namecreate type="text" class="form-control cls-text-input" placeholder="Tên người tạo"
                      formControlName="namecreate" name="name" maxlength="49" (keydown.enter)="phone.focus()">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-sm-6">
                  <div class="form-group">
                    <input #phone minlength="10" maxlength="14" phone name="phone" type="text" id="phone"
                      class="form-control cls-text-input" placeholder="Số điện thoại" formControlName="phone"
                      name="phone" (keydown.enter)="address.focus()">
                  </div>
                </div>
                <div class="col-lg-6 col-sm-6">
                  <div class="form-group">
                    <input #email name="email" type="email" class="form-control cls-text-input"
                      placeholder="Email của bạn" name="email" formControlName="email" (keydown.enter)="user.focus()">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-sm-6">
                  <div class="form-group">
                    <input #user type="text" class="form-control cls-text-input" placeholder="Tên đăng nhập"
                      formControlName="user" name="user" required (keydown.enter)="password.focus()">
                  </div>
                </div>
                <div class="col-lg-6 col-sm-6">
                  <div class="form-group">
                    <input #password minlength="6" name="pass" class="form-control cls-text-input"
                      placeholder="Mật khẩu" type="password" formControlName="password" required>
                  </div>
                </div>
              </div>
              <div class="form-btn text-center">
                <button type="submit" class="default-btn" (click)="sendPost()">Đăng ký</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Log In Modal -->
  <div class="modal custom-modal fade" id="LogInModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Đăng nhập</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="user-form">
            <form>
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Email or Username">
              </div>

              <div class="form-group">
                <input type="password" class="form-control" placeholder="Password">
              </div>

              <div class="form-group form-check">
                <input type="checkbox" class="form-check-input" id="exampleCheck1">
                <label class="form-check-label" for="exampleCheck1">Remember Me</label>
              </div>

              <div class="form-btn text-center">
                <button type="submit" class="default-btn">Log In</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Saas banner Area -->
  <div id="home" class="saas-banner-area">
    <div class="container">
      <div class="saas-banner-content">
        <h1>Oliu là hệ sinh thái phần mềm quản trị cơ sở y tế toàn diện</h1>

        <div class="saas-banner-btn">
          <a href="#SignUpModal" class="default-btn bg-white mr-2" data-toggle="modal" data-target="#SignUpModal">Dùng
            thử ngay</a>

        </div>
      </div>

      <div class="saas-banner-img">
        <img src="assets/images/saas-img/saas-laptop.png" class="saas-img-1" alt="Image">
        <img src="assets/images/saas-img/saas-mobile.png" class="saas-img-2" alt="Image">
      </div>

      <div class="saas-shape-content">
        <img src="assets/images/shape/shape1.png" class="saas-shape-1" alt="Shape">
        <img src="assets/images/shape/shape2.png" class="saas-shape-2" alt="Shape">
        <img src="assets/images/shape/shape3.png" class="saas-shape-3" alt="Shape">
        <img src="assets/images/shape/shape4.png" class="saas-shape-4" alt="Shape">
        <img src="assets/images/shape/shape5.png" class="saas-shape-5" alt="Shape">
        <img src="assets/images/shape/shape6.png" class="saas-shape-6" alt="Shape">
        <img src="assets/images/shape/shape7.png" class="saas-shape-7" alt="Shape">
      </div>
    </div>
  </div>
  <!-- End Saas banner Area -->

  <!-- Services Area -->
  <div id="services" class="saas-services-area pt-260 pb-40">
    <div class="container">
      <div class="section-title">

        <h2>Sản phẩm của Chúng Tôi</h2>
        <p>Tích hợp tất cả các ứng dụng quản lý cơ sở y tế của bạn đang cần trên cùng một nền tảng duy nhất.</p>
      </div>

      <div class="row">
        <div class="col-lg-4 col-sm-6">
          <div class="saas-service-card">
            <div class="icon bg-2">
              <img src="./assets/images/saas-img/clinic.jpg">
            </div>
            <h3>Phần Mềm Quản Lý cơ sở y tế</h3>

          </div>
        </div>

        <div class="col-lg-4 col-sm-6">
          <div class="saas-service-card">
            <div class="icon bg-2">
              <img src="./assets/images/saas-img/phongmach.jpg">
            </div>


            <h3>Phần Mềm Quản Lý Phòng mạch tư</h3>

          </div>
        </div>

        <div class="col-lg-4 col-sm-6">
          <div class="saas-service-card">
            <div class="icon bg-2">
              <img src="./assets/images/saas-img/spa.jpg">
            </div>
            <h3>Phần Mềm Quản Lý Thẩm Mỹ Viện - Spa</h3>

          </div>
        </div>

        <div class="col-lg-4 col-sm-6">
          <div class="saas-service-card">
            <div class="icon bg-2">
              <img src="./assets/images/saas-img/nhakhoa.jpg">
            </div>
            <h3>Phần Mềm Quản Lý Nha Khoa</h3>

          </div>
        </div>



        <div class="col-lg-4 col-sm-6">
          <div class="saas-service-card">
            <div class="icon bg-2">
              <img src="./assets/images/saas-img/phamacy.jpg">
            </div>
            <h3>Phần Mềm Quản Lý Nhà Thuốc</h3>

          </div>
        </div>
        <div class="col-lg-4 col-sm-6">
          <div class="saas-service-card">
            <div class="icon bg-2">
              <img src="./assets/images/saas-img/crm.jpg">
            </div>
            <h3>Phần Mềm Quản Khách Hàng Y TẾ</h3>

          </div>
        </div>
      </div>

      <div class="service-shape">
        <img src="assets/images/shape/shape12.png" alt="Shape">
      </div>
    </div>
  </div>
  <!-- End Services Area -->

  <!-- Features Area -->
  <div id="features" class="features-area ptb-50">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="features-contant">
            <div class="features-image">
              <img src="assets/images/saas-img/feature1.png" alt="Image">
            </div>

            <div class="features-shape">
              <img src="assets/images/shape/shape8.png" alt="Shape">
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="features-card-content">
            <h2 class="title">Quản lý và điều hành cơ sở y tế trở nên thật dễ dàng</h2>
            <div class="saas-features">
              <div class="icon bg-1">
                <i class="las la-sliders-h"></i>
              </div>
              <h3>Quản lý toàn diện</h3>
              <p>Xây dựng quy trình chuẩn dễ dàng và nhanh chóng cho mọi hoạt động của cơ sở y tế.</p>
            </div>

            <div class="saas-features">
              <div class="icon bg-2">
                <i class="las la-chart-bar bg-5"></i>
              </div>
              <h3>Báo cáo tự động</h3>
              <p>Data-driven khiến mọi thứ trở nên minh bạch và rõ ràng hơn.</p>
            </div>

            <div class="saas-features">
              <div class="icon bg-3">
                <i class="las la-swatchbook"></i>
              </div>
              <h3>Tuỳ chỉnh linh hoạt</h3>
              <p>Đáp ứng được hầu hết các phương thức quản lý và nhu cầu của cơ sở y tế.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Features Area -->



  <!-- Built SaaS App Area -->
  <div class="built-saas-app ptb-50">
    <div class="container">
      <div class="section-title">
        <h2>Liên kết toàn diện các quy trình và phòng ban trên cùng một nền tảng</h2>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div class="saas-feature-two">

            <i class="las la-layer-group  bg-1"></i>
            <h3> Quản lý mọi quy trình nghiệp vụ trong cơ sở y tế</h3>
            <p>Dễ dàng thiết lập, số hoá và chuẩn hoá tất cả các quy trình cơ sở y tế, tránh sai sót và lặp lại công
              việc.</p>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="saas-feature-two">
            <i class="las la-smile-beam bg-3"></i>
            <h3>Phối hợp nhịp nhàng hơn giữa các phòng ban</h3>
            <p>Liên kết để tự động chuyển giao giữa các quy trình, phát hiện ngay các điểm tắc nghẽn để cải tiến.</p>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="saas-feature-two">
            <i class="las la-crosshairs bg-3"></i>
            <h3>Chuẩn hoá và tối ưu luồng trao đổi thông tin</h3>
            <p>Làm việc hiệu quả hơn và thông minh hơn, tự động hoá các công việc, tiết kiệm thời gian và chi phí.</p>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="saas-feature-two">
            <i class="las la-search-plus bg-1"></i>
            <h3> Tìm kiếm hiệu quả</h3>
            <p>Tìm kiếm dữ liệu nhanh & dễ dàng theo tất cả các thông tin liên quan đến dữ liệu đó.</p>
          </div>
        </div>
      </div>
      <div class="parsonal-image">
        <img src="assets/images/saas-img/saas-lp-display.png" alt="Image">
      </div>
    </div>
  </div>
  <!-- End Built SaaS App Area -->
  <!-- Saas Download Area -->
  <div class="saas-downloand-area ptb-50">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="download-text">
            <div class="section-title">
              <span>MỞ RỘNG KHÔNG GIỚI HẠN</span>
              <h2>Các ứng dụng độc đáo, dễ sử dụng và hiệu năng cao được phát triển và ra mắt liên tục</h2>
            </div>

            <p>Nhiều hơn một ứng dụng công nghệ, Oliu được xây dựng với khả năng mở rộng vô hạn: Không chỉ với các ứng
              dụng hiện có,
              các ứng dụng mới để giải quyết các bài toán khác nhau của cơ sở y tế được liên tục phát triển và ra mắt.
            </p>

            <div class="app-image">
              <a href="#">
                <img src="assets/images/app-img/google-play.png" class="play-stroe" alt="Image">
              </a>
              <a href="#">
                <img src="assets/images/app-img/app-store.png" class="apple" alt="Image">
              </a>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="download-image">
            <img src="assets/images/saas-img/saas-mobile1.png" class="mobile-1" alt="Image">
            <img src="assets/images/saas-img/saas-mobile2.png" class="mobile-2" alt="Image">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Saas Download Area -->

  <!-- Popup Video Area -->
  <div class="popup-video-area bg-1">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="popup-video">
            <div class="video-btn">
              <a href="http://www.youtube.com/watch?v=0O2aH4XLbto" class="popup-youtube">
                <i class="las la-play"></i>
                <span class="ripple pinkBg"></span>
                <span class="ripple pinkBg"></span>
                <span class="ripple pinkBg"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Popup Video Area -->
  <!-- Pricing Area -->
  <div id="pricing" class="prising-area  pb-40">
    <div class="container">
      <div class="section-title">

        <h2>Bảng giá</h2>

      </div>

      <div class="row">
        <div class="col-lg-4 col-md-6">
          <div class="prising-card">
            <div class="price-header text-center">
              <h3>GÓI CƠ BẢN</h3>
              <h4>8.000.000đ</h4>
              <p>Năm</p>
            </div>

            <ul>
              <li>
                <i class="las la-check"></i>
                Tiếp nhận và Thanh toán
              </li>
              <li>
                <i class="las la-check"></i>
                Khám và tư vấn
              </li>
              <li>
                <i class="las la-check"></i>
                Quầy thuốc
              </li>
              <li>
                <i class="las la-check"></i>
                Lịch hẹn
              </li>
              <li>
                <i class="las la-check"></i>
                Quản trị khách hàng
              </li>
              <li class="not-provide">
                <i class="las la-times"></i>
                Quản trị marketing
              </li>
              <li>
                <i class="las la-check"></i>
                Kế toán
              </li>
              <li class="not-provide">
                <i class="las la-check"></i>
                Quản lý tài sản
              </li>

              <li class="not-provide">
                <i class="las la-times"></i>
                Quản lý kho
              </li>
              <li>
                <i class="las la-check"></i>
                Quản lý nhân sự
              </li>
              <li class="not-provide">
                <i class="las la-times"></i>
                Quản lý chi nhánh
              </li>
              <li>
                <i class="las la-times"></i>
                Báo cáo
              </li>
            </ul>

            <div class="price-btn text-center">

              <a href="#SignUpModal" class="default-btn bg-color" data-toggle="modal" data-target="#SignUpModal">Dùng
                thử ngay</a>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6">
          <div class="prising-card active">
            <div class="price-header text-center">
              <h3>GÓI TIÊU CHUẨN</h3>
              <h4>12.000.000đ</h4>
              <p>Năm</p>
            </div>

            <ul>
              <li>
                <i class="las la-check"></i>
                Tiếp nhận và Thanh toán
              </li>
              <li>
                <i class="las la-check"></i>
                Khám và tư vấn
              </li>
              <li>
                <i class="las la-check"></i>
                Quầy thuốc
              </li>
              <li>
                <i class="las la-check"></i>
                Lịch hẹn
              </li>
              <li>
                <i class="las la-check"></i>
                Quản trị khách hàng
              </li>
              <li>
                <i class="las la-check"></i>
                Quản trị marketing
              </li>
              <li>
                <i class="las la-check"></i>
                Kế toán
              </li>
              <li class="not-provide">
                <i class="las la-times"></i>
                Quản lý tài sản
              </li>

              <li>
                <i class="las la-check"></i>
                Quản lý kho
              </li>
              <li>
                <i class="las la-check"></i>
                Quản lý nhân sự
              </li>
              <li class="not-provide">
                <i class="las la-times"></i>
                Quản lý chi nhánh
              </li>
              <li>
                <i class="las la-check"></i>
                Báo cáo
              </li>
            </ul>

            <div class="price-btn text-center">
              <a href="#SignUpModal" class="default-btn bg-color" data-toggle="modal" data-target="#SignUpModal">Dùng
                thử ngay</a>

            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
          <div class="prising-card">
            <div class="price-header text-center">
              <h3>LIÊN HỆ</h3>
              <h4>&nbsp;</h4>
              <p>&nbsp;</p>
            </div>

            <ul>
              <li>
                <i class="las la-check"></i>
                Tiếp nhận và Thanh toán
              </li>
              <li>
                <i class="las la-check"></i>
                Khám và tư vấn
              </li>
              <li>
                <i class="las la-check"></i>
                Quầy thuốc
              </li>
              <li>
                <i class="las la-check"></i>
                Lịch hẹn
              </li>
              <li>
                <i class="las la-check"></i>
                Quản trị khách hàng
              </li>
              <li>
                <i class="las la-check"></i>
                Quản trị marketing
              </li>
              <li>
                <i class="las la-check"></i>
                Kế toán
              </li>
              <li>
                <i class="las la-check"></i>
                Quản lý tài sản
              </li>

              <li>
                <i class="las la-check"></i>
                Quản lý kho
              </li>
              <li>
                <i class="las la-check"></i>
                Quản lý nhân sự
              </li>
              <li>
                <i class="las la-check"></i>
                Quản lý chi nhánh
              </li>
              <li>
                <i class="las la-check"></i>
                Báo cáo
              </li>
            </ul>

            <div class="price-btn text-center">
              <a href="#SignUpModal" class="default-btn bg-color" data-toggle="modal" data-target="#SignUpModal">Dùng
                thử ngay</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Pricing Area -->


  <!-- Clients Area -->
  <!-- <div class="clients-area ptb-50">
      <div class="container">
          <div class="section-title">
             
              <h2>Hơn 5000 cơ sở y tế đã lựa chọn Oliu Platform</h2>
              <p>Để giúp mọi người làm việc hiệu quả hơn.</p>
          </div>
      </div>

      <div class="container">
          <div class="clients-slider owl-carousel owl-theme">
              <div class="clients-slider-item">
                  <div class="row align-items-center">
                      <div class="col-lg-6">
                          <div class="client-text">
                              <div class="text">
                                  <i class="las la-quote-left text-icon-1"></i>
                                  <p>Có Oliu khiến chúng tôi an tâm hơn, quản lý cơ sở y tế tốt hơn,
                                       đồng thời nắm rõ được tình hình khám chữa bệnh nhân qua các thống kê, báo cáo..</p>
                                  <i class="las la-quote-right text-icon-2"></i>
                              </div>
                              <div class="rating">
                                  <i class="las la-star"></i>
                                  <i class="las la-star"></i>
                                  <i class="las la-star"></i>
                                  <i class="las la-star"></i>
                                  <i class="las la-star"></i>
                              </div>
                              <h3>Bác sĩ Nguyễn Mai Dung</h3>
                              <span>CEO - cơ sở y tế da liễu Hà Nội</span>
                          </div>
                      </div>
                      <div class="col-lg-6">
                          <div class="client-image">
                              <img src="assets/images/partner/bsdung.png" alt="Image">
                          </div>
                      </div>
                  </div>
              </div>

              <div class="clients-slider-item">
                  <div class="row align-items-center">
                      <div class="col-lg-6">
                          <div class="client-text">
                              <div class="text">
                                  <i class="las la-quote-left text-icon-1"></i>
                                  <p>
                                          Từ khi sử dụng Oliu, khâu quản lý của chúng tôi được cải thiện hơn rất nhiều. 
                                          Chăm sóc khách hàng tốt hơn, marketing ưu việt hơn, và cũng ít bị xảy ra nhầm lẫn trong việc tính toán tiền thừa cho khách hàng. 
                                  </p>
                                  <i class="las la-quote-right text-icon-2"></i>
                              </div>
                              <div class="rating">
                                  <i class="las la-star"></i>
                                  <i class="las la-star"></i>
                                  <i class="las la-star"></i>
                                  <i class="las la-star"></i>
                                  <i class="las la-star"></i>
                              </div>
                              <h3>Bác sĩ Trần Tuấn Anh</h3>
                              <span>CEO - Thẩm mỹ viện Tuấn Anh</span>
                          </div>
                      </div>
                      <div class="col-lg-6">
                          <div class="client-image">
                              <img src="assets/images/partner/bstuananh.png" alt="Image">
                          </div>
                      </div>
                  </div>
              </div>

              <div class="clients-slider-item">
                  <div class="row align-items-center">
                      <div class="col-lg-6">
                          <div class="client-text">
                              <div class="text">
                                  <i class="las la-quote-left text-icon-1"></i>
                                  <p>
                                          Tôi không còn phải đau đầu tính toán các con số sau 1 ngày làm việc nữa. Oliu đã trở thành người bạn thân thiết của tôi.</p>
                                  <i class="las la-quote-right text-icon-2"></i>
                              </div>
                              <div class="rating">
                                  <i class="las la-star"></i>
                                  <i class="las la-star"></i>
                                  <i class="las la-star"></i>
                                  <i class="las la-star"></i>
                                  <i class="las la-star"></i>
                              </div>
                              <h3>Trần Huyền Trang</h3>
                              <span>CEO Chaing Spa</span>
                          </div>
                      </div>
                      <div class="col-lg-6">
                          <div class="client-image">
                              <img src="assets/images/partner/trangspa.png" alt="Image">
                          </div>
                      </div>
                  </div>
              </div>

               <div class="clients-slider-item">
                  <div class="row align-items-center">
                      <div class="col-lg-6">
                          <div class="client-text">
                              <div class="text">
                                  <i class="las la-quote-left text-icon-1"></i>
                                  <p>Oliu platform Nền tảng quản lý và tự động hoá quy trình nghiệp cơ sở y tế</p>
                                  <i class="las la-quote-right text-icon-2"></i>
                              </div>
                              <div class="rating">
                                  <i class="las la-star"></i>
                                  <i class="las la-star"></i>
                                  <i class="las la-star"></i>
                                  <i class="las la-star"></i>
                                  <i class="las la-star"></i>
                              </div>
                              <h3>Benjamin Liam</h3>
                              <span>CEO Of LTD Company</span>
                          </div>
                      </div>
                      <div class="col-lg-6">
                          <div class="client-image">
                              <img src="assets/images/saas-img//client4.jpg" alt="Image">
                          </div>
                      </div>
                  </div>
              </div> 
          </div>
          <div class="claint-shape">
              <img src="assets/images/shape/shape9.png" class="shape-9" alt="Shape">
              <img src="assets/images/shape/shape10.png" class="shape-10" alt="Shape">
          </div>
      </div>
  </div>-->
  <!-- End Clients Area -->

  <!-- Partner Slider Area -->
  <!--  <div class="partner-area ptb-100">
      <div class="container">
          <div class="partner-slider owl-carousel owl-theme">
              <div class="partner-slider-item">
                  <a href="#">
                      <img src="assets/images/partner/dalieu.png" alt="logo">
                  </a>
              </div>

              <div class="partner-slider-item">
                  <a href="#">
                      <img src="assets/images/partner/nhicao.png" alt="logo">
                  </a>
              </div>

              <div class="partner-slider-item">
                  <a href="#">
                      <img src="assets/images/partner/tuananh.png" alt="logo">
                  </a>
              </div>

              <div class="partner-slider-item">
                  <a href="#">
                      <img src="assets/images/partner/charginspa.png" alt="logo">
                  </a>
              </div>

              <div class="partner-slider-item">
                  <a href="#">
                      <img src="assets/images/partner/bvdakhoahanoi.png" alt="logo">
                  </a>
              </div>

              <div class="partner-slider-item">
                  <a href="#">
                      <img src="assets/images/partner/pklaha.png" alt="logo">
                  </a>
              </div>
          </div>
      </div>
  </div>-->
  <!-- End Partner Slider Area -->

  <!-- Contact Area -->
  <div id="contact" class="contact-area ptb-50">
    <div class="container">
      <div class="section-title">
        <h2>Liên hệ</h2>
        <p>Oliu platform nền tảng quản lý và tự động hoá quy trình nghiệp vụ cơ sở y tế</p>
      </div>

      <div class="contact-content">
        <form id="contactForm">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <input type="text" name="name" class="form-control" id="name" required
                  data-error="Vui lòng nhập họ tên của Bạn" placeholder="Họ và tên">
                <div class="help-block with-errors"></div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <input type="email" name="email" class="form-control" id="email" required
                  data-error="Vui lòng nhập email của Bạn" placeholder="Email">
                <div class="help-block with-errors"></div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <input type="text" name="msg_subject" id="msg_subject" class="form-control" r equired
                  data-error="Nhập chủ đề liên hệ" placeholder="Chủ đề liên hệ">
                <div class="help-block with-errors"></div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <input type="text" name="phone_number" class="form-control" id="phone_number" required
                  data-error="Nhập số điện thoại của Bạn" placeholder="Nhập số điện thoại">
                <div class="help-block with-errors"></div>
              </div>
            </div>

            <div class="col-lg-12 col-md-12">
              <div class="form-group">
                <textarea name="message" id="message" class="form-control" cols="30" rows="6" required
                  data-error="Nhập nội dung liên hệ" placeholder="Nội dung liên hệ..."></textarea>
                <div class="help-block with-errors"></div>
              </div>
            </div>

            <div class="col-lg-12 col-md-12 text-center">
              <button type="submit" class="default-btn">Gửi liên hệ</button>
              <div id="msgSubmit" class="h3 text-center hidden"></div>
              <div class="clearfix"></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- End Contact Area -->

  <!-- Subscribe Area -->
  <div class="subscribe-area mt-minus-50" style="padding-bottom: 50px;">
    <div class="container">
      <div class="subscribe-contant">
        <div class="row align-items-center">
          <div class="col-lg-6">
            <div class="subscrive-text">
              <h3>Đăng ký nhận thông tin</h3>
              <p>Chúng Tôi sẽ gửi thông tin khuyến mại, chính sách cũng như nâng cấp hoặc ra các phiên bản phần mềm mới
                tới Bạn.</p>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="subscribe-form">
              <form class="newsletter-form" data-toggle="validator">
                <input type="email" class="form-control" placeholder="Nhập địa chỉ email" name="EMAIL" required=""
                  autocomplete="off">
                <button type="submit" class="btn btn-primary">Đăng ký</button>

                <div id="validator-newsletter" class="form-result"></div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Subscribe Area -->

  <!-- Footer Area -->
  <footer class="footer-area pt-200 bor-radius-right">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="footer-widget">
            <div class="logo">
              <img src="assets/images/logo-white.png" alt="logo">
            </div>
            <p style="text-align: justify;">
              Oliu là hệ sinh thái phần mềm quản trị cơ sở y tế phổ biến tại Việt Nam, đang được tin dùng bởi hơn
              1,000 cơ sở y tế thuộc nhiều lĩnh vực khác nhau. Hầu hết các cơ sở y tế
              tăng trưởng nhanh đang dùng một trong số các sản phẩm của Oliu.



            </p>
            <p style="text-align: justify;">

              Tất cả các ứng dụng trên Oliu có thể sử dụng dễ dàng trên trình duyệt,
              smartphone (iOS), máy tính bảng.
              Tất cả các ứng dụng chính đều hỗ trợ đa ngôn ngữ (Tiếng Việt, English) và nâng cấp liên tục

            </p>
            <ul class="footer-social">
              <li>
                <a class="bg-1" href="#" target="_blank">
                  <i class="lab la-facebook-f bg-1"></i>
                </a>
              </li>
              <li>
                <a class="bg-2" href="#" target="_blank">
                  <i class="lab la-twitter bg-2"></i>
                </a>
              </li>
              <li>
                <a class="bg-3" href="#" target="_blank">
                  <i class="lab la-linkedin-in bg-3"></i>
                </a>
              </li>
              <li>
                <a class="bg-4" href="#" target="_blank">
                  <i class="lab la-instagram bg-4"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-lg-5 col-md-6 col-sm-6">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="footer-widget">
                <h3 class="title">Công ty</h3>
                <ul class="footer-text">
                  <li>
                    <a href="#about">
                      <i class="las la-angle-right"></i>
                      Giới thiệu
                    </a>
                  </li>
                  <li>
                    <a href="#vision">
                      <i class="las la-angle-right"></i>
                      Tầm nhìn
                    </a>
                  </li>
                  <li>
                    <a href="#human">
                      <i class="las la-angle-right"></i>
                      Đội ngũ
                    </a>
                  </li>
                  <li>
                    <a href="#newspapers">
                      <i class="las la-angle-right"></i>
                      Báo chí
                    </a>
                  </li>
                  <li>
                    <a href="#contact">
                      <i class="las la-angle-right"></i>
                      Liên hệ
                    </a>
                  </li>

                </ul>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
              <div class="footer-widget">
                <h3 class="title">Chính sách</h3>
                <ul class="footer-text">
                  <li>
                    <a href="#paymentModal" data-toggle="modal" data-target="#paymentModal">
                      <i class="las la-angle-right"></i>
                      Chính sách thanh toán
                    </a>
                  </li>
                  <li>
                    <a href="#securityModal" data-toggle="modal" data-target="#securityModal">
                      <i class="las la-angle-right"></i>
                      Chính sách bảo mật
                    </a>
                  </li>
                  <li>
                    <a href="#policyModal" data-toggle="modal" data-target="#policyModal">
                      <i class="las la-angle-right"></i>
                      Điều khoản sử dụng
                    </a>
                  </li>
                  <li>
                    <a href="#pricing">
                      <i class="las la-angle-right"></i>
                      Bảng giá
                    </a>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 offset-md-4 offset-sm-4 offset-lg-0">
          <div class="footer-widget">
            <h3 class="title">Ứng dụng Oliu đã có trên</h3>
            <div class="footer-image">
              <a href="#">
                <img src="assets/images/app-img/google-play.png" alt="Image">
              </a>
              <a href="#">
                <img src="assets/images/app-img/app-store.png" alt="Image">
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- Log In Modal -->
      <div class="modal custom-modal fade" id="paymentModal">
        <div class="modal-dialog modal-dialog-centered" style="max-width:950px">
          <div class="modal-content" style="max-width:950px;max-height: 650px;  overflow-y: auto;">
            <div class="modal-header">
              <h5 class="modal-title">Chính sách thanh toán</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body" style="max-width:950px">
              <div class="user-form">
                <p><strong>Gi&aacute; cả v&agrave; phương thức thanh to&aacute;n</strong></p>

                <ol>
                  <li>Lần đầu ti&ecirc;n khi bắt đầu sử dụng phần mềm, kh&aacute;ch h&agrave;ng thanh to&aacute;n
                    ph&iacute; khởi tạo v&agrave; ph&iacute; thu&ecirc; bao cho 1VIETNAM</li>
                  <li>Kh&aacute;ch h&agrave;ng chịu tr&aacute;ch nhiệm thanh to&aacute;n cho 1VIETNAM 100% gi&aacute;
                    trị của g&oacute;i sản phẩm/dịch vụ m&agrave; kh&aacute;ch h&agrave;ng chọn mua ngay sau khi
                    kh&aacute;ch h&agrave;ng gửi đơn đặt h&agrave;ng cho 1VIETNAM</li>
                  <li>Thời điểm bắt đầu t&iacute;nh ph&iacute; thu&ecirc; bao được t&iacute;nh từ ng&agrave;y 1VIETNAM
                    b&agrave;n giao cho kh&aacute;ch h&agrave;ng th&ocirc;ng tin truy cập v&agrave;o phần mềm căn cứ
                    v&agrave;o email th&ocirc;ng b&aacute;o của 1VIETNAM</li>
                  <li>Việc thanh to&aacute;n ph&iacute; thu&ecirc; bao cho kỳ tiếp theo phải được thực hiện trước
                    ng&agrave;y hết hạn của kỳ thu&ecirc; bao trước đ&oacute;. 1VIETNAM sẽ gửi th&ocirc;ng b&aacute;o về
                    việc đ&oacute;ng ph&iacute; thu&ecirc; bao trực tiếp tr&ecirc;n ch&iacute;nh phần mềm OLIU hoặc
                    DAISY m&agrave; kh&aacute;ch h&agrave;ng đang sử dụng (quy định tại điều 6.5a)</li>
                  <li>1VIETNAM c&oacute; quyền điều chỉnh mức ph&iacute; thu&ecirc; bao theo gi&aacute; thị trường,
                    v&agrave; c&ocirc;ng bố trực tiếp tr&ecirc;n website&nbsp;<a
                      href="http://oliu.io/">http://oliu.io</a> hoặc&nbsp;<a
                      href="http://1vietnam.vn/">http://1vietnam.vn</a>.&nbsp; &nbsp; Trong trường hợp kh&aacute;ch
                    h&agrave;ng đ&atilde; thanh to&aacute;n ph&iacute; thu&ecirc; bao cho nhiều kỳ th&igrave; mức
                    ph&iacute; thu&ecirc; bao sẽ kh&ocirc;ng thay đổi trong suốt thời hạn thu&ecirc; bao m&agrave;
                    kh&aacute;ch h&agrave;ng đ&atilde; thanh to&aacute;n</li>
                  <li>Kh&aacute;ch h&agrave;ng chịu tr&aacute;ch nhiệm thanh to&aacute;n cho 1VIETNAM bằng tiền mặt,
                    chuyển khoản hoặc thanh to&aacute;n trực tuyến th&ocirc;ng qua ng&acirc;n h&agrave;ng hoặc đối
                    t&aacute;c thứ ba. Trường hợp thanh to&aacute;n bằng tiền mặt, kh&aacute;ch h&agrave;ng chỉ thanh
                    to&aacute;n cho c&aacute;n bộ của 1VIETNAM khi c&aacute;n bộ đ&oacute; xuất tr&igrave;nh đủ
                    c&aacute;c giấy tờ sau đ&acirc;y: Giấy giới thiệu của C&ocirc;ng ty/Văn ph&ograve;ng đại điện
                    C&ocirc;ng ty cổ phần đầu tư v&agrave; ph&aacute;t triển c&ocirc;ng nghệ số 1 Việt Nam về việc nhận
                    tiền mặt (c&oacute; ghi r&otilde; số tiền), thẻ nh&acirc;n vi&ecirc;n của 1VIETNAM, bản gốc chứng
                    minh thư nh&acirc;n d&acirc;n hoặc thẻ căn cước của người được ghi trong giấy giới thiệu.</li>
                  <li>1VIETNAM kh&ocirc;ng chấp nhận ho&agrave;n trả bất kể chi ph&iacute; n&agrave;o m&agrave;
                    kh&aacute;ch h&agrave;ng đ&atilde; thanh to&aacute;n cho 1VIETNAM v&agrave; sau khi 1VIETNAM
                    đ&atilde; ho&agrave;n th&agrave;nh nghĩa vụ b&agrave;n giao sản phẩm, dịch vụ cho kh&aacute;ch
                    h&agrave;ng</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="modal custom-modal fade" id="securityModal">
        <div class="modal-dialog modal-dialog-centered" style="max-width:950px">
          <div class="modal-content" style="max-width:950px;max-height: 650px;  overflow-y: auto;">
            <div class="modal-header">
              <h5 class="modal-title">Chính sách bảo mật</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body" style="max-width:950px">
              <div class="user-form">
                <p><strong>Cập nhật, bảo h&agrave;nh, bảo tr&igrave;</strong></p>

                <ol>
                  <li>1VIETNAM chịu tr&aacute;ch nhiệm đảm bảo điều kiện kỹ thuật để kh&aacute;ch h&agrave;ng c&oacute;
                    thể sử dụng được phần mềm 24h/ng&agrave;y v&agrave; 7ng&agrave;y/tuần ngoại trừ thời gian bảo
                    tr&igrave;, n&acirc;ng cấp, khắc phục sự cố cho hệ thống. Thời gian ngừng hệ thống để bảo tr&igrave;
                    hoặc n&acirc;ng cấp hoặc sao lưu sẽ được 1VIETNAM b&aacute;o trước lịch thực hiện cho kh&aacute;ch
                    h&agrave;ng theo h&igrave;nh thức th&ocirc;ng b&aacute;o trực tiếp tr&ecirc;n phần mềm. Lịch bảo
                    tr&igrave; hoặc n&acirc;ng cấp hoặc sao lưu sẽ thực hiện theo định kỳ h&agrave;ng ng&agrave;y hoặc
                    h&agrave;ng tuần hoặc h&agrave;ng th&aacute;ng hoặc h&agrave;ng năm v&agrave; ưu ti&ecirc;n
                    v&agrave;o buổi đ&ecirc;m khi hệ thống &iacute;t sử dụng nhất</li>
                  <li>1VIETNAM c&oacute; tr&aacute;ch nhiệm tiến h&agrave;nh khắc phục sự cố của hệ thống chậm nhất
                    l&agrave; 8h l&agrave;m việc kể từ khi tiếp nhận được y&ecirc;u cầu từ người sử dụng của
                    kh&aacute;ch h&agrave;ng</li>
                  <li>1VIETNAM c&oacute; tr&aacute;ch nhiệm cập nhật phi&ecirc;n bản mới nhất của phần mềm miễn
                    ph&iacute; cho kh&aacute;ch h&agrave;ng trong thời hạn thu&ecirc; bao m&agrave; kh&aacute;ch
                    h&agrave;ng đ&atilde; đăng k&yacute; v&agrave; thanh to&aacute;n cho 1VIETNAM</li>
                  <li>Kh&aacute;ch h&agrave;ng đồng &yacute; chấp nhận tất cả sự v&aacute; lỗi, sửa lỗi, n&acirc;ng cấp,
                    bảo tr&igrave; cần thiết c&aacute;c t&iacute;nh năng của dịch vụ hoạt động ch&iacute;nh x&aacute;c
                    v&agrave; đảm bảo t&iacute;nh bảo mật của dịch vụ. Trừ trường hợp khẩn cấp, 1VIETNAM sẽ th&ocirc;ng
                    b&aacute;o trước tới kh&aacute;ch h&agrave;ng lịch tr&igrave;nh của c&aacute;c hoạt động sửa lỗi,
                    n&acirc;ng cấp n&agrave;y</li>
                  <li>Khi gần hết hạn sử dụng, hết hạn thu&ecirc; bao phần mềm, 1VIETNAM c&oacute; tr&aacute;ch nhiệm
                    th&ocirc;ng b&aacute;o cho kh&aacute;ch h&agrave;ng trực tiếp tr&ecirc;n ch&iacute;nh phần mềm OLIU
                    hoặc DAISY như sau:</li>
                  <li>Trong v&ograve;ng 30 ng&agrave;y trước ng&agrave;y hết hạn: Th&ocirc;ng b&aacute;o cho
                    kh&aacute;ch h&agrave;ng biết thời hạn c&ograve;n lại của thu&ecirc; bao v&agrave; hướng dẫn
                    kh&aacute;ch h&agrave;ng l&agrave;m thủ tục gia hạn thu&ecirc; bao</li>
                  <li>Khi hết hạn thu&ecirc; bao, 1VIETNAM sẽ th&ocirc;ng b&aacute;o cho kh&aacute;ch h&agrave;ng biết
                    thu&ecirc; bao đ&atilde; qu&aacute; hạn v&agrave; hướng dẫn kh&aacute;ch h&agrave;ng l&agrave;m thủ
                    tục gia hạn thu&ecirc;. Kh&aacute;ch h&agrave;ng sẽ kh&ocirc;ng được đăng nhập để sử dụng phần mềm
                    khi hết hạn thu&ecirc; bao</li>
                  <li>Qu&aacute; hạn tr&ecirc;n 30 ng&agrave;y, 1VIETNAM sẽ thực hiện cắt thu&ecirc; bao của
                    kh&aacute;ch h&agrave;ng</li>
                  <li>Kh&aacute;ch h&agrave;ng c&oacute; thể tự chủ động tra cứu thời hạn sử dụng của thu&ecirc; bao
                    đ&atilde; sử dụng ngay tr&ecirc;n phần mềm theo t&agrave;i liệu hướng dẫn sử dụng phần mềm</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Log In Modal -->
      <div class="modal custom-modal fade" id="policyModal">
        <div class="modal-dialog modal-dialog-centered" style="max-width:950px">
          <div class="modal-content" style="max-width:950px;max-height: 650px;  overflow-y: auto;">
            <div class="modal-header">
              <h5 class="modal-title">Điều khoản sử dụng</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body" style="max-width:950px">
              <div class="user-form">
                <p>THOẢ THUẬN SỬ DỤNG PHẦN MỀM/ DỊCH VỤ</p>

                <p><em>Phi&ecirc;n bản v1.0 ng&agrave;y 08/07/2020</em></p>

                <p><strong>Điều 1: C&aacute;c thuật ngữ sử dụng trong thoả thuận</strong></p>

                <p><strong>Điều 2: Quyền sử dụng phần mềm</strong></p>

                <p><strong>Điều 3: Gi&aacute; cả v&agrave; phương thức thanh to&aacute;n</strong></p>

                <p><strong>Điều 4: B&agrave;n giao sản phẩm, dịch vụ</strong></p>

                <p><strong>Điều 5: Tư vấn v&agrave; hỗ trợ kh&aacute;ch h&agrave;ng&nbsp;</strong></p>

                <p><strong>Điều 6: Cập nhật, bảo h&agrave;nh, bảo tr&igrave;</strong></p>

                <p><strong>Điều 7: D&ugrave;ng thử dịch vụ&nbsp;</strong></p>

                <p><strong>Điều 8: Bảo mật</strong></p>

                <p><strong>Điều 9: Bản quyền phần mềm v&agrave; dữ liệu</strong></p>

                <p><strong>Điều 10: Phạm vi giới hạn v&agrave; tr&aacute;ch nhiệm của 1VIETNAM trong sử dụng phần
                    mềm</strong></p>

                <p><strong>Điều 11: Th&ocirc;ng tin/ th&ocirc;ng b&aacute;o</strong></p>

                <p><strong>Điều 12: Th&ocirc;ng tin ph&aacute;i sinh</strong></p>

                <p><strong>Điều 13: Giới hạn tr&aacute;ch nhiệm ph&aacute;p l&yacute; v&agrave; thực hiện dịch
                    vụ</strong></p>

                <p><strong>Điều 14: Tr&aacute;ch nhiệm xử l&yacute; sự cố an ninh</strong></p>

                <p><strong>Điều 15: Trường hợp bất khả kh&aacute;ng</strong></p>

                <p><strong>Điều 16: Tạm ngưng v&agrave; chấm dứt thoả thuận</strong></p>

                <p><strong>Điều 17: Điều khoản sửa đổi, bổ sung thoả thuận</strong></p>

                <p><strong>Điều 18: Căn cứ ph&aacute;p l&yacute;</strong></p>

                <p><strong>Điều 19: Điều khoản chung</strong></p>

                <p><strong>Đ&acirc;y l&agrave; thoả thuận ph&aacute;p l&yacute; giữa kh&aacute;ch h&agrave;ng với
                    C&ocirc;ng ty cổ phần đầu tư v&agrave; ph&aacute;t triển c&ocirc;ng nghệ số 1 Việt Nam, quy định
                    c&aacute;c điều khoản trong việc kh&aacute;ch h&agrave;ng sử dụng dịch vụ phần mềm quản l&yacute;
                    ph&ograve;ng kh&aacute;m OLIU.IO. Thoả thuận n&agrave;y l&agrave; hợp đồng điện tử giữa hai
                    b&ecirc;n. Bằng c&aacute;ch nhấp chuột v&agrave;o n&uacute;t &ldquo;Đồng &yacute;&rdquo; khi đăng
                    k&yacute; sử dụng, kh&aacute;ch h&agrave;ng đồng &yacute; rằng c&aacute;c điều khoản n&agrave;y sẽ
                    được &aacute;p dụng nếu kh&aacute;ch h&agrave;ng lựa chọn truy cập hoặc sử dụng dịch vụ v&agrave;
                    thao t&aacute;c nhấp chuột n&agrave;y tương đương với việc hai b&ecirc;n đ&atilde; k&yacute; kết hợp
                    đồng.</strong></p>

                <p><strong>Điều 1: C&aacute;c thuật ngữ sử dụng trong thoả thuận</strong></p>

                <ol>
                  <li><strong>Phần mềm:&nbsp;</strong>Phần mềm Quản l&yacute; ph&ograve;ng kh&aacute;m mang t&ecirc;n
                    OLIU hoặc DAISY do 1VIETNAM cung cấp bao gồm: phi&ecirc;n bản quản l&yacute; online tr&ecirc;n web
                    v&agrave; c&aacute;c phi&ecirc;n bản c&agrave;i đặt tr&ecirc;n m&aacute;y t&iacute;nh, m&aacute;y
                    t&iacute;nh bảng, điện thoại, smart Tivi v&agrave; c&aacute;c ứng dụng hỗ trợ kh&aacute;c đi
                    k&egrave;m với phần mềm OLIU hoặc DAISY</li>
                  <li><strong>Hệ thống:&nbsp;</strong>Bao gồm c&aacute;c m&aacute;y chủ đặt tại trung t&acirc;m dữ liệu
                    của 1VIETNAM, được c&agrave;i đặt c&aacute;c phần mềm hệ thống v&agrave; phần mềm OLIU hoặc DAISY
                  </li>
                  <li><strong>1VIETNAM:&nbsp;</strong>L&agrave; C&ocirc;ng ty cổ phần đầu tư v&agrave; ph&aacute;t triển
                    c&ocirc;ng nghệ số 1 Việt Nam, nh&agrave; cung cấp dịch vụ phần mềm OLIU hoặc DAISY</li>
                  <li><strong>Kh&aacute;ch h&agrave;ng:&nbsp;</strong> L&agrave; tổ chức hoặc c&aacute; nh&acirc;n đứng
                    ra đăng k&yacute; d&ugrave;ng thử hoặc trả tiền sử dụng dịch vụ phần mềm OLIU hoặc DAISY</li>
                  <li><strong>Ph&iacute; khởi tạo:&nbsp;</strong>L&agrave; khoản ph&iacute; m&agrave; kh&aacute;ch
                    h&agrave;ng thanh to&aacute;n một lần duy nhất cho 1VIETNAM để khởi tạo sử dụng phần mềm lần đầu
                    ti&ecirc;n</li>
                  <li><strong>Ph&iacute; thu&ecirc; bao:&nbsp;</strong>L&agrave; khoản ph&iacute; m&agrave; kh&aacute;ch
                    h&agrave;ng thanh to&aacute;n cho 1VIETNAM để duy tr&igrave; sử dụng phần mềm. Ph&iacute; thu&ecirc;
                    bao được t&iacute;nh h&agrave;ng th&aacute;ng v&agrave; kh&aacute;ch h&agrave;ng c&oacute; thể thanh
                    to&aacute;n trước cho nhiều th&aacute;ng khi đặt mua</li>
                  <li><strong>Thời gian thu&ecirc; bao:&nbsp;</strong>L&agrave; khoảng thời gian kh&aacute;ch
                    h&agrave;ng được cấp quyền sử dụng dịch vụ phần mềm OLIU hoặc DAISY theo y&ecirc;u cầu đăng
                    k&yacute; v&agrave; thoả thuận thanh to&aacute;n ph&iacute; với 1VIETNAM</li>
                  <li><strong>Gia hạn thu&ecirc; bao:&nbsp;</strong>L&agrave; việc 1VIETNAM cấp th&ecirc;m thời gian sử
                    dụng dịch vụ phần mềm OLIU hoặc DAISY cho kh&aacute;ch h&agrave;ng theo thoả thuận của hai b&ecirc;n
                  </li>
                  <li><strong>Th&ocirc;ng tin ph&aacute;i sinh:&nbsp;</strong>L&agrave; th&ocirc;ng tin được tổng hợp,
                    suy luận từ c&aacute;c th&ocirc;ng tin gốc do kh&aacute;ch h&agrave;ng tạo ra trong phần mềm của
                    1VIETNAM. V&iacute; dụ: Th&ocirc;ng tin ph&aacute;i sinh từ phần mềm OLIU c&aacute; nh&acirc;n
                    c&oacute; thể l&agrave; B&aacute;o c&aacute;o về độ tuổi trung b&igrave;nh của người Việt Nam mắc
                    bệnh kh&ocirc;ng l&acirc;y nhiễm,&hellip;</li>
                </ol>

                <p><strong>Điều 2: Quyền sử dụng phần mềm</strong></p>

                <ol>
                  <li>Kh&aacute;ch h&agrave;ng c&oacute; quyền sử dụng đầy đủ c&aacute;c t&iacute;nh năng của phần mềm
                    trong thời gian thu&ecirc; bao c&ograve;n hạn sử dụng</li>
                  <li>Đối với mỗi thu&ecirc; bao kh&aacute;ch h&agrave;ng đ&atilde; đăng k&yacute; v&agrave; thanh
                    to&aacute;n tiền sử dụng th&igrave; sẽ được cấp một t&ecirc;n miền theo đăng k&yacute; của
                    kh&aacute;ch h&agrave;ng để sử dụng v&agrave; chứa dữ liệu của kh&aacute;ch h&agrave;ng. Trường hợp
                    kh&aacute;ch h&agrave;ng muốn thay đổi lại t&ecirc;n miền kh&aacute;c th&igrave; kh&aacute;ch
                    h&agrave;ng sẽ l&agrave;m đề nghị đổi t&ecirc;n miền theo quy định của 1VIETNAM. Sau khi cấp
                    t&ecirc;n miền mới, 1VIETNAM sẽ cắt thu&ecirc; bao của t&ecirc;n miền cũ để đảm bảo mỗi thuế bao của
                    kh&aacute;ch h&agrave;ng chỉ c&oacute; một t&ecirc;n miền duy nhất được duy tr&igrave;</li>
                  <li>Kh&aacute;ch h&agrave;ng kh&ocirc;ng được ph&eacute;p sử dụng dịch vụ phần mềm để thực hiện
                    c&aacute;c h&agrave;nh vi cập nhật dữ liệu, gửi email, viết b&agrave;i, truyền tải dữ liệu v&agrave;
                    c&aacute;c h&agrave;nh vi kh&aacute;c với mục đ&iacute;ch sau:</li>
                  <li>L&agrave;m tổn hại, l&agrave;m phiền cho người kh&aacute;c hoặc g&acirc;y ra thương tổn đến con
                    người v&agrave; t&agrave;i sản;</li>
                  <li>Li&ecirc;n quan đến việc c&ocirc;ng bố c&aacute;c th&ocirc;ng tin hoặc t&agrave;i liệu lừa đảo,
                    g&acirc;y mất uy t&iacute;n danh dự, quấy rối hoặc mang t&iacute;nh khi&ecirc;u d&acirc;m;</li>
                  <li>X&acirc;m phạm c&aacute;c quyền ri&ecirc;ng tư hoặc k&igrave; thị chủng tộc, t&ocirc;n
                    gi&aacute;o, giới t&iacute;nh, người t&agrave;n tật;</li>
                  <li>X&acirc;m phạm quyền sở hữu tr&iacute; tuệ hoặc c&aacute;c quyền sở hữu kh&aacute;c;</li>
                  <li>Cản trở hoặc ph&aacute; hỏng Dịch vụ (bao gồm nhưng kh&ocirc;ng giới hạn bởi việc truy cập Dịch vụ
                    th&ocirc;ng qua bất cứ phương tiện m&aacute;y m&oacute;c, phần mềm);</li>
                  <li>Vi phạm quy định ph&aacute;p luật;</li>
                  <li>Trước khi hết hạn, kh&aacute;ch h&agrave;ng cần thực hiện thủ tục gia hạn thu&ecirc; bao để tiếp
                    tục sử dụng phần mềm. Thời điểm gia hạn l&agrave; thời điểm t&iacute;nh từ ng&agrave;y hết hạn của
                    kỳ đăng k&yacute; sử dụng trước đ&oacute;.</li>
                  <li>Khi hết hạn thu&ecirc; bao, kh&aacute;ch h&agrave;ng sẽ kh&ocirc;ng được đăng nhập để sử dụng phần
                    mềm nữa.</li>
                  <li>Khi thu&ecirc; bao qu&aacute; hạn tr&ecirc;n 30 ng&agrave;y, nếu kh&aacute;ch h&agrave;ng chưa
                    l&agrave;m thủ tục đăng k&yacute; v&agrave; thanh to&aacute;n gia hạn thu&ecirc; bao th&igrave;
                    1VIETNAM sẽ l&agrave;m thủ tục cắt thu&ecirc; bao.</li>
                  <li>Khi thực hiện cắt thu&ecirc; bao sử dụng phần mềm, 1VIETNAM sẽ th&ocirc;ng b&aacute;o qua email
                    trong c&aacute;c trường hợp sau:</li>
                  <li>Kh&aacute;ch h&agrave;ng kh&ocirc;ng l&agrave;m thủ tục đăng k&yacute; gia hạn, thanh to&aacute;n
                    với 1VIETNAM nếu thu&ecirc; bao qu&aacute; hạn sử dụng dịch vụ tr&ecirc;n 30 ng&agrave;y;</li>
                  <li>Kh&aacute;ch h&agrave;ng y&ecirc;u cầu cắt thu&ecirc; bao phần mềm;</li>
                  <li>Kh&aacute;ch h&agrave;ng vi phạm mục đ&iacute;ch sử dụng phần mềm n&agrave;y được n&ecirc;u trong
                    thoả thuận n&agrave;y;</li>
                  <li>Kh&aacute;ch h&agrave;ng vi phạm ph&aacute;p luật v&agrave; cơ quan c&oacute; thẩm quyền y&ecirc;u
                    cầu 1VIETNAM dừng cung cấp dịch vụ thu&ecirc; bao cho kh&aacute;ch h&agrave;ng;</li>
                </ol>

                <p><strong>Điều 3: Gi&aacute; cả v&agrave; phương thức thanh to&aacute;n</strong></p>

                <ol>
                  <li>Lần đầu ti&ecirc;n khi bắt đầu sử dụng phần mềm, kh&aacute;ch h&agrave;ng thanh to&aacute;n
                    ph&iacute; khởi tạo v&agrave; ph&iacute; thu&ecirc; bao cho 1VIETNAM</li>
                  <li>Kh&aacute;ch h&agrave;ng chịu tr&aacute;ch nhiệm thanh to&aacute;n cho 1VIETNAM 100% gi&aacute;
                    trị của g&oacute;i sản phẩm/dịch vụ m&agrave; kh&aacute;ch h&agrave;ng chọn mua ngay sau khi
                    kh&aacute;ch h&agrave;ng gửi đơn đặt h&agrave;ng cho 1VIETNAM</li>
                  <li>Thời điểm bắt đầu t&iacute;nh ph&iacute; thu&ecirc; bao được t&iacute;nh từ ng&agrave;y 1VIETNAM
                    b&agrave;n giao cho kh&aacute;ch h&agrave;ng th&ocirc;ng tin truy cập v&agrave;o phần mềm căn cứ
                    v&agrave;o email th&ocirc;ng b&aacute;o của 1VIETNAM</li>
                  <li>Việc thanh to&aacute;n ph&iacute; thu&ecirc; bao cho kỳ tiếp theo phải được thực hiện trước
                    ng&agrave;y hết hạn của kỳ thu&ecirc; bao trước đ&oacute;. 1VIETNAM sẽ gửi th&ocirc;ng b&aacute;o về
                    việc đ&oacute;ng ph&iacute; thu&ecirc; bao trực tiếp tr&ecirc;n ch&iacute;nh phần mềm OLIU hoặc
                    DAISY m&agrave; kh&aacute;ch h&agrave;ng đang sử dụng (quy định tại điều 6.5a)</li>
                  <li>1VIETNAM c&oacute; quyền điều chỉnh mức ph&iacute; thu&ecirc; bao theo gi&aacute; thị trường,
                    v&agrave; c&ocirc;ng bố trực tiếp tr&ecirc;n website&nbsp;<a
                      href="http://oliu.io/">http://oliu.io</a> hoặc&nbsp;<a
                      href="http://1vietnam.vn/">http://1vietnam.vn</a>.&nbsp; &nbsp; Trong trường hợp kh&aacute;ch
                    h&agrave;ng đ&atilde; thanh to&aacute;n ph&iacute; thu&ecirc; bao cho nhiều kỳ th&igrave; mức
                    ph&iacute; thu&ecirc; bao sẽ kh&ocirc;ng thay đổi trong suốt thời hạn thu&ecirc; bao m&agrave;
                    kh&aacute;ch h&agrave;ng đ&atilde; thanh to&aacute;n</li>
                  <li>Kh&aacute;ch h&agrave;ng chịu tr&aacute;ch nhiệm thanh to&aacute;n cho 1VIETNAM bằng tiền mặt,
                    chuyển khoản hoặc thanh to&aacute;n trực tuyến th&ocirc;ng qua ng&acirc;n h&agrave;ng hoặc đối
                    t&aacute;c thứ ba. Trường hợp thanh to&aacute;n bằng tiền mặt, kh&aacute;ch h&agrave;ng chỉ thanh
                    to&aacute;n cho c&aacute;n bộ của 1VIETNAM khi c&aacute;n bộ đ&oacute; xuất tr&igrave;nh đủ
                    c&aacute;c giấy tờ sau đ&acirc;y: Giấy giới thiệu của C&ocirc;ng ty/Văn ph&ograve;ng đại điện
                    C&ocirc;ng ty cổ phần đầu tư v&agrave; ph&aacute;t triển c&ocirc;ng nghệ số 1 Việt Nam về việc nhận
                    tiền mặt (c&oacute; ghi r&otilde; số tiền), thẻ nh&acirc;n vi&ecirc;n của 1VIETNAM, bản gốc chứng
                    minh thư nh&acirc;n d&acirc;n hoặc thẻ căn cước của người được ghi trong giấy giới thiệu.</li>
                  <li>1VIETNAM kh&ocirc;ng chấp nhận ho&agrave;n trả bất kể chi ph&iacute; n&agrave;o m&agrave;
                    kh&aacute;ch h&agrave;ng đ&atilde; thanh to&aacute;n cho 1VIETNAM v&agrave; sau khi 1VIETNAM
                    đ&atilde; ho&agrave;n th&agrave;nh nghĩa vụ b&agrave;n giao sản phẩm, dịch vụ cho kh&aacute;ch
                    h&agrave;ng</li>
                </ol>

                <p><strong>Điều 4: B&agrave;n giao sản phẩm, dịch vụ</strong></p>

                <ol>
                  <li>1VIETNAM chịu tr&aacute;ch nhiệm b&agrave;n giao cho kh&aacute;ch h&agrave;ng quyền sử dụng phần
                    mềm trong v&ograve;ng 07 ng&agrave;y sau khi kh&aacute;ch h&agrave;ng ho&agrave;n th&agrave;nh nghĩa
                    vụ thanh to&aacute;n cho 1VIETNAM</li>
                  <li>Kh&aacute;ch h&agrave;ng chịu tr&aacute;ch nhiệm đăng nhập v&agrave;o phần mềm để kiểm tra thời
                    hạn sử dụng dịch vụ theo th&ocirc;ng tin truy cập do 1VIETNAM gửi th&ocirc;ng b&aacute;o qua email.
                    Khi kh&aacute;ch h&agrave;ng đăng nhập v&agrave;o phần mềm th&igrave; xem như 1VIETNAM đ&atilde;
                    ho&agrave;n th&agrave;nh nghĩa vụ b&agrave;n giao sản phẩm v&agrave; việc t&iacute;nh ph&iacute; bắt
                    đầu từ thời điểm n&agrave;y</li>
                  <li>Kh&aacute;ch h&agrave;ng chịu tr&aacute;ch nhiệm chuẩn bị đầy đủ thiết bị, nh&acirc;n lực
                    v&agrave; đường truyền theo đ&uacute;ng khuyến c&aacute;o của 1VIETNAM ghi trong phần mềm để tổ chức
                    khai th&aacute;c, vận h&agrave;nh hệ thống phần mềm</li>
                  <li>Kh&aacute;ch h&agrave;ng chịu tr&aacute;ch nhiệm tiếp nhận, sử dụng phần mềm theo đ&uacute;ng
                    hướng dẫn v&agrave; khuyến c&aacute;o sử dụng phần mềm của 1VIETNAM c&ocirc;ng bố trong phần mềm
                  </li>
                  <li>Khi tiếp nhận b&agrave;n giao t&agrave;i khoản truy cập từ 1VIETNAM, kh&aacute;ch h&agrave;ng
                    c&oacute; tr&aacute;ch nhiệm thay đổi mật khẩu ngầm định ngay trong lần đầu ti&ecirc;n sử dụng phần
                    mềm</li>
                </ol>

                <p><strong>Điều 5: Tư vấn v&agrave; hỗ trợ kh&aacute;ch h&agrave;ng</strong></p>

                <ol>
                  <li>1VIETNAM chịu tr&aacute;ch nhiệm cung cấp dịch vụ tư vấn hỗ trợ cho kh&aacute;ch h&agrave;ng trong
                    suốt qu&aacute; tr&igrave;nh sử dụng phần mềm OLIU hoặc DAISY th&ocirc;ng qua tổng đ&agrave;i tư vấn
                    phần mềm 1VIETNAM, email v&agrave; c&aacute;c h&igrave;nh thức hỗ trợ kh&aacute;c được c&ocirc;ng bố
                    tại website&nbsp;<a href="http://oliu.io/">http://oliu.io</a></li>
                  <li>Kh&aacute;ch h&agrave;ng chủ động xem, khai th&aacute;c c&aacute;c t&agrave;i liệu, phim hướng dẫn
                    sử dụng phần mềm đặt tại&nbsp;<a href="http://help.oliu.io/">http://help.oliu.io</a>v&agrave;
                    c&aacute;c trang hỗ trợ kh&aacute;c được c&ocirc;ng bố tại website&nbsp;<a
                      href="http://oliu.io/">http://oliu.io</a></li>
                  <li>Khi sử dụng dịch vụ tư vấn qua tổng đ&agrave;i tư vấn phần mềm 1VIETNAM Support kh&aacute;ch
                    h&agrave;ng chấp nhận trả cước ph&iacute; điện thoại theo quy định của nh&agrave; cung cấp dịch vụ
                    viễn th&ocirc;ng</li>
                  <li>C&aacute;c dịch vụ tư vấn hỗ trợ th&ocirc;ng qua h&igrave;nh thức kh&aacute;c (như dịch vụ tư vấn
                    hỗ trợ tại c&aacute;c địa điểm theo y&ecirc;u cầu của kh&aacute;ch h&agrave;ng, dịch vụ t&aacute;i
                    đ&agrave;o tạo hướng dẫn sử dụng cho kh&aacute;ch h&agrave;ng) sẽ được hai b&ecirc;n thống nhất về
                    chi ph&iacute; v&agrave; phương thức cung cấp bằng văn bản bổ sung khi c&oacute; ph&aacute;t sinh
                    y&ecirc;u cầu</li>
                </ol>

                <p><strong>Điều 6: Cập nhật, bảo h&agrave;nh, bảo tr&igrave;</strong></p>

                <ol>
                  <li>1VIETNAM chịu tr&aacute;ch nhiệm đảm bảo điều kiện kỹ thuật để kh&aacute;ch h&agrave;ng c&oacute;
                    thể sử dụng được phần mềm 24h/ng&agrave;y v&agrave; 7ng&agrave;y/tuần ngoại trừ thời gian bảo
                    tr&igrave;, n&acirc;ng cấp, khắc phục sự cố cho hệ thống. Thời gian ngừng hệ thống để bảo tr&igrave;
                    hoặc n&acirc;ng cấp hoặc sao lưu sẽ được 1VIETNAM b&aacute;o trước lịch thực hiện cho kh&aacute;ch
                    h&agrave;ng theo h&igrave;nh thức th&ocirc;ng b&aacute;o trực tiếp tr&ecirc;n phần mềm. Lịch bảo
                    tr&igrave; hoặc n&acirc;ng cấp hoặc sao lưu sẽ thực hiện theo định kỳ h&agrave;ng ng&agrave;y hoặc
                    h&agrave;ng tuần hoặc h&agrave;ng th&aacute;ng hoặc h&agrave;ng năm v&agrave; ưu ti&ecirc;n
                    v&agrave;o buổi đ&ecirc;m khi hệ thống &iacute;t sử dụng nhất</li>
                  <li>1VIETNAM c&oacute; tr&aacute;ch nhiệm tiến h&agrave;nh khắc phục sự cố của hệ thống chậm nhất
                    l&agrave; 8h l&agrave;m việc kể từ khi tiếp nhận được y&ecirc;u cầu từ người sử dụng của
                    kh&aacute;ch h&agrave;ng</li>
                  <li>1VIETNAM c&oacute; tr&aacute;ch nhiệm cập nhật phi&ecirc;n bản mới nhất của phần mềm miễn
                    ph&iacute; cho kh&aacute;ch h&agrave;ng trong thời hạn thu&ecirc; bao m&agrave; kh&aacute;ch
                    h&agrave;ng đ&atilde; đăng k&yacute; v&agrave; thanh to&aacute;n cho 1VIETNAM</li>
                  <li>Kh&aacute;ch h&agrave;ng đồng &yacute; chấp nhận tất cả sự v&aacute; lỗi, sửa lỗi, n&acirc;ng cấp,
                    bảo tr&igrave; cần thiết c&aacute;c t&iacute;nh năng của dịch vụ hoạt động ch&iacute;nh x&aacute;c
                    v&agrave; đảm bảo t&iacute;nh bảo mật của dịch vụ. Trừ trường hợp khẩn cấp, 1VIETNAM sẽ th&ocirc;ng
                    b&aacute;o trước tới kh&aacute;ch h&agrave;ng lịch tr&igrave;nh của c&aacute;c hoạt động sửa lỗi,
                    n&acirc;ng cấp n&agrave;y</li>
                  <li>Khi gần hết hạn sử dụng, hết hạn thu&ecirc; bao phần mềm, 1VIETNAM c&oacute; tr&aacute;ch nhiệm
                    th&ocirc;ng b&aacute;o cho kh&aacute;ch h&agrave;ng trực tiếp tr&ecirc;n ch&iacute;nh phần mềm OLIU
                    hoặc DAISY như sau:</li>
                  <li>Trong v&ograve;ng 30 ng&agrave;y trước ng&agrave;y hết hạn: Th&ocirc;ng b&aacute;o cho
                    kh&aacute;ch h&agrave;ng biết thời hạn c&ograve;n lại của thu&ecirc; bao v&agrave; hướng dẫn
                    kh&aacute;ch h&agrave;ng l&agrave;m thủ tục gia hạn thu&ecirc; bao</li>
                  <li>Khi hết hạn thu&ecirc; bao, 1VIETNAM sẽ th&ocirc;ng b&aacute;o cho kh&aacute;ch h&agrave;ng biết
                    thu&ecirc; bao đ&atilde; qu&aacute; hạn v&agrave; hướng dẫn kh&aacute;ch h&agrave;ng l&agrave;m thủ
                    tục gia hạn thu&ecirc;. Kh&aacute;ch h&agrave;ng sẽ kh&ocirc;ng được đăng nhập để sử dụng phần mềm
                    khi hết hạn thu&ecirc; bao</li>
                  <li>Qu&aacute; hạn tr&ecirc;n 30 ng&agrave;y, 1VIETNAM sẽ thực hiện cắt thu&ecirc; bao của
                    kh&aacute;ch h&agrave;ng</li>
                  <li>Kh&aacute;ch h&agrave;ng c&oacute; thể tự chủ động tra cứu thời hạn sử dụng của thu&ecirc; bao
                    đ&atilde; sử dụng ngay tr&ecirc;n phần mềm theo t&agrave;i liệu hướng dẫn sử dụng phần mềm</li>
                </ol>

                <p><strong>Điều 7: D&ugrave;ng thử dịch vụ</strong></p>

                <ol>
                  <li>Kh&aacute;ch h&agrave;ng tự đăng k&yacute; t&agrave;i khoản d&ugrave;ng thử phần mềm tại
                    website&nbsp;<a href="http://oliu.io/">http://oliu.io</a> . Khi d&ugrave;ng thử phần mềm OLIU hoặc
                    DAISY, kh&aacute;ch h&agrave;ng được:</li>
                  <li>Sử dụng đầy đủ mọi chức năng của phần mềm</li>
                  <li>Thời hạn sử dụng d&ugrave;ng thử l&agrave; 15 ng&agrave;y</li>
                  <li>1VIETNAM sẽ th&ocirc;ng b&aacute;o cho kh&aacute;ch h&agrave;ng biết về thời hạn của t&agrave;i
                    khoản d&ugrave;ng thử dịch vụ phần mềm OLIU hoặc DAISY như sau:</li>
                  <li>Trong v&ograve;ng 15 ng&agrave;y trước ng&agrave;y hết hạn, 1VIETNAM sẽ th&ocirc;ng b&aacute;o cho
                    kh&aacute;ch h&agrave;ng biết về thời hạn sử dụng c&ograve;n lại v&agrave; hướng dẫn kh&aacute;ch
                    h&agrave;ng l&agrave;m thủ tục đăng k&yacute; ch&iacute;nh thức</li>
                  <li>Khi hết hạn d&ugrave;ng thử, 1VIETNAM sẽ th&ocirc;ng b&aacute;o cho kh&aacute;ch h&agrave;ng biết
                    thu&ecirc; bao d&ugrave;ng thử đ&atilde; hết hạn v&agrave; hướng dẫn kh&aacute;ch h&agrave;ng
                    l&agrave;m thủ tục đăng k&yacute; ch&iacute;nh thức. Kh&aacute;ch h&agrave;ng sẽ kh&ocirc;ng được
                    đăng nhập để sử dụng phần mềm khi hết hạn d&ugrave;ng thử</li>
                  <li>Qu&aacute; hạn d&ugrave;ng thử tr&ecirc;n 30 ng&agrave;y, 1VIETNAM sẽ thực hiện việc cắt
                    thu&ecirc; bao v&agrave; xo&aacute; bỏ dữ liệu d&ugrave;ng thử của kh&aacute;ch h&agrave;ng</li>
                  <li>Khi kh&aacute;ch h&agrave;ng đăng k&yacute; sử dụng d&ugrave;ng thử dịch vụ phần mềm OLIU hoặc
                    DAISY, 1VIETNAM sẽ cung cấp miễn ph&iacute; dịch vụ cho kh&aacute;ch h&agrave;ng cho tới khi:</li>
                  <li>Hết thời hạn d&ugrave;ng thử</li>
                  <li>Kh&aacute;ch h&agrave;ng ch&iacute;nh thức d&ugrave;ng dịch vụ trước khi hết hạn d&ugrave;ng thử
                  </li>
                  <li>1VIETNAM sẽ kh&ocirc;ng chịu tr&aacute;ch nhiệm về bất cứ quyền lợi n&agrave;o của kh&aacute;ch
                    h&agrave;ng li&ecirc;n quan đến qu&aacute; tr&igrave;nh d&ugrave;ng thử n&agrave;y</li>
                  <li>Khi hết thời hạn d&ugrave;ng thử, to&agrave;n bộ dữ liệu d&ugrave;ng thử của kh&aacute;ch
                    h&agrave;ng sẽ bị xo&aacute; khỏi hệ thống, trừ trường hợp kh&aacute;ch h&agrave;ng đăng k&yacute;
                    chuyển sang h&igrave;nh thức thu&ecirc; bao ch&iacute;nh thức v&agrave; được 1VIETNAM chấp nhận</li>
                </ol>

                <p><strong>Điều 8: Bảo mật</strong></p>

                <ol>
                  <li>1VIETNAM chịu tr&aacute;ch nhiệm thực hiện v&agrave; duy tr&igrave; tất cả c&aacute;c biện
                    ph&aacute;p bảo vệ mang t&iacute;nh h&agrave;nh ch&iacute;nh, vật l&yacute; v&agrave; kỹ thuật để
                    đảm bảo t&iacute;nh bảo mật v&agrave; to&agrave;n vẹn đối với dữ liệu kh&aacute;ch h&agrave;ng.
                    1VIETNAM cam kết:</li>
                  <li>Kh&ocirc;ng đổi dữ liệu kh&aacute;ch h&agrave;ng m&agrave; kh&ocirc;ng c&oacute; sự đồng &yacute;
                    của kh&aacute;ch h&agrave;ng hoặc kh&ocirc;ng phải v&igrave; mục đ&iacute;ch khắc phục lỗi hay sự cố
                  </li>
                  <li>Kh&ocirc;ng tiết lộ dữ liệu kh&aacute;ch h&agrave;ng trừ trường hợp phải tu&acirc;n theo quy định
                    của ph&aacute;p luật hoặc được kh&aacute;ch h&agrave;ng cho ph&eacute;p</li>
                  <li>Kh&ocirc;ng truy cập v&agrave;o dữ liệu v&agrave; hoặc l&agrave;m thay đổi dữ liệu của
                    kh&aacute;ch h&agrave;ng trừ trường hợp khắc phục lỗi kỹ thuật hoặc theo y&ecirc;u cầu của
                    kh&aacute;ch h&agrave;ng khi sử dụng dịch vụ hỗ trợ</li>
                  <li>1VIETNAM chịu tr&aacute;ch nhiệm bảo mật mọi th&ocirc;ng tin về dữ liệu của kh&aacute;ch
                    h&agrave;ng v&agrave; kh&ocirc;ng được ph&eacute;p tiết lộ cho bất kỳ b&ecirc;n thứ ba n&agrave;o
                    kh&aacute;c ngoại trừ y&ecirc;u cầu của cơ quan c&oacute; thẩm quyền của nh&agrave; nước. 1VIETNAM
                    kh&ocirc;ng chịu tr&aacute;ch nhiệm về c&aacute;c thất tho&aacute;t dữ liệu, bảo mật th&ocirc;ng tin
                    của kh&aacute;ch h&agrave;ng do kh&aacute;ch h&agrave;ng v&ocirc; t&igrave;nh hoặc cố y g&acirc;y ra
                  </li>
                  <li>Kh&aacute;ch h&agrave;ng chịu tr&aacute;ch nhiệm x&aacute;c định v&agrave; x&aacute;c thực quyền
                    của tất cả những người d&ugrave;ng truy nhập v&agrave; dữ liệu của kh&aacute;ch h&agrave;ng</li>
                  <li>Kh&aacute;ch h&agrave;ng chịu tr&aacute;ch nhiệm đảm bảo b&iacute; mật th&ocirc;ng tin t&agrave;i
                    khoản người d&ugrave;ng</li>
                  <li>Kh&aacute;ch h&agrave;ng chịu tr&aacute;ch nhiệm đối với to&agrave;n bộ c&aacute;c hoạt động thực
                    hiện bởi t&agrave;i khoản người d&ugrave;ng của kh&aacute;ch h&agrave;ng v&agrave; c&oacute;
                    tr&aacute;ch nhiệm ngay lập tức th&ocirc;ng b&aacute;o với 1VIETNAM về c&aacute;c truy cập
                    tr&aacute;i ph&eacute;p</li>
                  <li>1VIETNAM kh&ocirc;ng chịu bất cứ tr&aacute;ch nhiệm n&agrave;o li&ecirc;n quan đến c&aacute;c tổn
                    hại g&acirc;y ra bởi người d&ugrave;ng của kh&aacute;ch h&agrave;ng, bao gồm việc c&aacute;c
                    c&aacute; nh&acirc;n kh&ocirc;ng c&oacute; quyền truy cập v&agrave;o dịch vụ vẫn c&oacute; thể lấy
                    được quyền truy cập do lỗi m&aacute;y t&iacute;nh, lỗi phần mềm, do lỗi hệ thống mạng nội bộ của
                    kh&aacute;ch h&agrave;ng, hoặc do bất cứ sự thiếu thận trọng n&agrave;o của người d&ugrave;ng của
                    kh&aacute;ch h&agrave;ng</li>
                  <li>Trong phạm vi của thoả thuận n&agrave;y, &ldquo;Th&ocirc;ng tin b&iacute; mật&rdquo; bao gồm: Dữ
                    liệu của kh&aacute;ch h&agrave;ng, c&ocirc;ng nghệ độc quyền của mỗi b&ecirc;n, quy tr&igrave;nh
                    nghiệp vụ v&agrave; c&aacute;c th&ocirc;ng tin kỹ thuật của sản phẩm, thiết kế v&agrave; to&agrave;n
                    bộ qu&aacute; tr&igrave;nh trao đổi giữa hai b&ecirc;n li&ecirc;n quan đến dịch vụ. Ngo&agrave;i
                    những nội dung đ&atilde; đề cập ở tr&ecirc;n, &ldquo;Th&ocirc;ng tin b&iacute; mật&rdquo;
                    kh&ocirc;ng bao gồm c&aacute;c th&ocirc;ng tin:</li>
                  <li>Được c&ocirc;ng ch&uacute;ng biết tới</li>
                  <li>Được biết tới trong ng&agrave;nh trước khi tiết lộ</li>
                  <li>Được c&ocirc;ng ch&uacute;ng biết tới kh&ocirc;ng phải lỗi của b&ecirc;n nhận th&ocirc;ng tin</li>
                  <li>Dữ liệu tổng hợp trong đ&oacute; kh&ocirc;ng chứa bất kỳ th&ocirc;ng tin c&aacute; nh&acirc;n hoặc
                    th&ocirc;ng tin cụ thể của kh&aacute;ch h&agrave;ng</li>
                </ol>

                <p><strong>Điều 9: Bản quyền phần mềm v&agrave; dữ liệu</strong></p>

                <ol>
                  <li>1VIETNAM l&agrave; chủ sở hữu v&agrave; c&oacute; quyền t&aacute;c giả đối với phần mềm OLIU
                    v&agrave; DAISY</li>
                  <li>Kh&aacute;ch h&agrave;ng c&oacute; quyền sử dụng phần mềm để tạo ra dữ liệu phục vụ c&ocirc;ng
                    việc của đơn vị v&agrave; c&oacute; quyền tải về phần mềm dữ liệu do ch&iacute;nh đơn vị nhập
                    v&agrave;o hệ thống trong suốt thời gian được cấp thu&ecirc; bao sử dụng phần mềm</li>
                  <li>Kh&aacute;ch h&agrave;ng đồng &yacute; rằng sản phẩm/dịch vụ, bao gồm v&agrave; kh&ocirc;ng giới
                    hạn c&aacute;c nội dung sau đ&acirc;y: giao diện người sử dụng, đoạn &acirc;m thanh, đoạn video, nội
                    dung hướng dẫn sử dụng v&agrave; phần mềm được sử dụng để thực hiện sản phẩm/dịch vụ thuộc sở hữu
                    ri&ecirc;ng của 1VIETNAM v&agrave; được bảo hộ bởi ph&aacute;p luật về sở hữu tr&iacute; tuệ
                    v&agrave; quyền t&aacute;c giả. Kh&aacute;ch h&agrave;ng thoả thuận sẽ kh&ocirc;ng sử dụng
                    c&aacute;c th&ocirc;ng tin hoặc t&agrave;i liệu thuộc sở hữu ri&ecirc;ng đ&oacute; theo bất cứ
                    c&aacute;ch thức n&agrave;o ngoại trừ cho mục đ&iacute;ch sử dụng sản phẩm/dịch vụ theo Thoả thuận
                    n&agrave;y. Kh&ocirc;ng c&oacute; phần mềm n&agrave;o trong sản phẩm/dịch vụ c&oacute; thể được sao
                    ch&eacute;p lại dưới bất kỳ h&igrave;nh thức n&agrave;o hoặc bất cứ phương tiện n&agrave;o, trừ khi
                    được cho ph&eacute;p một c&aacute;ch r&otilde; r&agrave;ng theo c&aacute;c điều khoản n&agrave;y
                  </li>
                  <li>Việc sử dụng phần mềm hoặc bất cứ phần n&agrave;o của sản phẩm/dịch vụ, trừ khi việc sử dụng sản
                    phẩm/dịch vụ được cho ph&eacute;p theo thoả thuận n&agrave;y, đều bị nghi&ecirc;m cấm v&agrave;
                    x&acirc;m phạm đến c&aacute;c quyền sở hữu tr&iacute; tuệ của người kh&aacute;c, v&agrave;
                    kh&aacute;ch h&agrave;ng c&oacute; thể phải chịu c&aacute;c biện ph&aacute;p xử l&yacute; theo quy
                    định của ph&aacute;p luật về h&agrave;nh ch&iacute;nh, h&igrave;nh sự, d&acirc;n sự bao gồm cả việc
                    bồi thường thiệt hại bằng tiền đối với việc x&acirc;m phạm quyền t&aacute;c giả</li>
                  <li>Để 1VIETNAM c&oacute; thể cung cấp dịch vụ sử dụng phần mềm cho kh&aacute;ch h&agrave;ng,
                    kh&aacute;ch h&agrave;ng đồng &yacute; cho 1VIETNAM quyền xử l&yacute;, truyền tải dữ liệu của
                    kh&aacute;ch h&agrave;ng</li>
                </ol>

                <p><strong>Điều 10: Phạm vi giới hạn tr&aacute;ch nhiệm của 1VIETNAM trong sử dụng phần mềm</strong></p>

                <ol>
                  <li>1VIETNAM c&oacute; quyền nhưng kh&ocirc;ng c&oacute; nghĩa vụ n&agrave;o trong việc thực hiện
                    c&aacute;c h&agrave;nh động khắc phục nếu như c&oacute; bất cứ nội dung n&agrave;o m&agrave;
                    kh&aacute;ch h&agrave;ng vi phạm c&aacute;c điều được liệt k&ecirc; trong thoả thuận n&agrave;y.
                    1VIETNAM kh&ocirc;ng c&oacute; bất kỳ tr&aacute;ch nhiệm ph&aacute;p l&yacute; n&agrave;o đối với
                    kh&aacute;ch h&agrave;ng trong c&aacute;c t&igrave;nh huống 1VIETNAM thực hiện h&agrave;nh động khắc
                    phục. Kh&aacute;ch h&agrave;ng l&agrave; người duy nhất chịu tr&aacute;ch nhiệm về t&iacute;nh
                    ch&iacute;nh x&aacute;c, chất lượng, t&iacute;nh to&agrave;n vẹn, hợp ph&aacute;p, tin cậy v&agrave;
                    ph&ugrave; hợp đối với tất cả dữ liệu của m&igrave;nh</li>
                  <li>1VIETNAM c&oacute; thể đề nghị v&agrave; kh&aacute;ch h&agrave;ng c&oacute; thể lựa chọn đồng
                    &yacute; sử dụng c&aacute;c t&iacute;nh năng được ph&aacute;t h&agrave;nh rộng r&atilde;i v&agrave;
                    chưa được kiểm duyệt ho&agrave;n to&agrave;n về mặt chất lượng theo quy tr&igrave;nh của 1VIETNAM
                    (c&aacute;c chức năng Beta). Mục đ&iacute;ch của việc n&agrave;y l&agrave; để kh&aacute;ch
                    h&agrave;ng kiểm duyệt v&agrave; cung cấp phản hồi cho 1VIETNAM. Kh&aacute;ch h&agrave;ng
                    ho&agrave;n to&agrave;n chịu tr&aacute;ch nhiệm về những rủi ro khi sử dụng c&aacute;c chức năng
                    n&agrave;y. 1VIETNAM kh&ocirc;ng đảm bảo về t&iacute;nh đ&uacute;ng đắn, đầy đủ của c&aacute;c chức
                    năng Beta cũng như kh&ocirc;ng chịu tr&aacute;ch nhiệm cho c&aacute;c lỗi hoặc thiệt hại g&acirc;y
                    ra do việc sử dụng c&aacute;c t&iacute;nh năng Beta</li>
                </ol>

                <p><strong>Điều 11: Th&ocirc;ng tin/ th&ocirc;ng b&aacute;o</strong></p>

                <p>Trong qu&aacute; tr&igrave;nh sử dụng phần mềm, kh&aacute;ch h&agrave;ng đồng &yacute; nhận
                  c&aacute;c th&ocirc;ng tin/ th&ocirc;ng b&aacute;o do 1VIETNAM gửi với nội dung v&agrave; phương thức
                  như sau:</p>

                <ol>
                  <li>Nội dung c&aacute;c th&ocirc;ng b&aacute;o bao gồm v&agrave; kh&ocirc;ng giới hạn c&aacute;c loại
                    th&ocirc;ng tin như sau:</li>
                  <li>Th&ocirc;ng tin về c&aacute;c t&iacute;nh năng mới của sản phẩm</li>
                  <li>Th&ocirc;ng tin về c&aacute;c phi&ecirc;n bản mới của sản phẩm</li>
                  <li>Th&ocirc;ng tin về c&aacute;c sản phẩm c&oacute; li&ecirc;n quan</li>
                  <li>Th&ocirc;ng tin về nội dung c&aacute;c b&agrave;i b&aacute;o hoặc bản tin m&agrave; 1VIETNAM cho
                    rằng c&oacute; thể hữu &iacute;ch cho kh&aacute;ch h&agrave;ng trong qu&aacute; tr&igrave;nh hoạt
                    động</li>
                </ol>

                <ul>
                  <li>Phương thức gửi th&ocirc;ng b&aacute;o bao gồm v&agrave; kh&ocirc;ng giới hạn c&aacute;c
                    h&igrave;nh thức sau:</li>
                  <li>Th&ocirc;ng b&aacute;o trực tiếp đến m&agrave;n h&igrave;nh sản phẩm</li>
                  <li>Th&ocirc;ng b&aacute;o qua email</li>
                  <li>Th&ocirc;ng b&aacute;o qua tin nhắn tr&ecirc;n điện thoại di động</li>
                  <li>Th&ocirc;ng b&aacute;o qua điện thoại</li>
                  <li>Th&ocirc;ng b&aacute;o qua văn bản</li>
                  <li>Th&ocirc;ng b&aacute;o bằng c&aacute;ch gặp trao đổi trực tiếp</li>
                  <li>C&aacute;c h&igrave;nh thức th&ocirc;ng b&aacute;o kh&aacute;c</li>
                </ul>

                <p><strong>Điều 12: Th&ocirc;ng tin ph&aacute;i sinh</strong></p>

                <p>1VIETNAM được quyền sử dụng th&ocirc;ng tin ph&aacute;i sinh từ một phần mềm hoặc to&agrave;n bộ
                  th&ocirc;ng tin do kh&aacute;ch h&agrave;ng tạo ra khi sử dụng sản phẩm của 1VIETNAM để phục vụ cho
                  c&aacute;c mục đ&iacute;ch nghi&ecirc;n cứu cải tiến sản phẩm, thị trường, th&oacute;i quen ti&ecirc;u
                  d&ugrave;ng v&agrave; c&aacute;c mục đ&iacute;ch kh&aacute;c c&oacute; thể mang lại lợi nhuận hoặc
                  kh&ocirc;ng mang lại lợi nhuận. 1VIETNAM cam kết c&aacute;c th&ocirc;ng tin ph&aacute;i sinh
                  n&agrave;y kh&ocirc;ng chứa đựng bất cứ dữ liệu cụ thể n&agrave;o li&ecirc;n quan đến th&ocirc;ng tin
                  c&aacute; nh&acirc;n của kh&aacute;ch h&agrave;ng (t&ecirc;n, ng&agrave;y sinh, giới t&iacute;nh, số
                  điện thoại, địa chỉ), c&aacute;c giao dịch cụ thể hoặc c&aacute;c b&iacute; mật sản xuất kinh doanh
                  (đ&atilde; m&ocirc; tả trong mục 1)</p>

                <p><strong>Điều 13: Giới hạn tr&aacute;ch nhiệm ph&aacute;p l&yacute; v&agrave; thực hiện dịch
                    vụ</strong></p>

                <ol>
                  <li>1VIETNAM kh&ocirc;ng cam đoan, tuy&ecirc;n bố, hoặc đảm bảo rằng việc kh&aacute;ch h&agrave;ng sử
                    dụng sản phẩm/dịch vụ của 1VIETNAM sẽ kh&ocirc;ng bị gi&aacute;n đoạn hoặc kh&ocirc;ng bị lỗi, hoặc
                    sản phẩm/dịch vụ sẽ đ&aacute;p ứng được y&ecirc;u cầu kh&aacute;ch h&agrave;ng hoặc tất cả
                    c&aacute;c lỗi tr&ecirc;n phần mềm hoặc t&agrave;i liệu sẽ được sửa hoặc hệ thống tổng thể đảm bảo
                    hoạt động của sản phẩm/dịch vụ phần mềm (bao gồm nhưng kh&ocirc;ng giới hạn: mạng internet,
                    c&aacute;c mạng truyền dẫn kh&aacute;c, mạng nội bộ v&agrave; c&aacute;c thiết bị của kh&aacute;ch
                    h&agrave;ng) sẽ kh&ocirc;ng c&oacute; virus hoặc kh&ocirc;ng c&oacute; th&agrave;nh phần g&acirc;y
                    hại</li>
                  <li>1VIETNAM kh&ocirc;ng đảm bảo dưới bất kỳ h&igrave;nh thức n&agrave;o, đủ r&otilde; r&agrave;ng hay
                    ngầm định về c&aacute;c điều kiện như sự thoả m&atilde;n về chất lượng, ph&ugrave; hợp cho nhu cầu
                    sử dụng đặc th&ugrave; hoặc kh&ocirc;ng x&acirc;m phạm c&aacute;c quyền của b&ecirc;n thứ ba. Dịch
                    vụ của 1VIETNAM được cung cấp cho kh&aacute;ch h&agrave;ng dưới dạng &ldquo;theo hiện trạng&rdquo;
                    v&agrave; &ldquo;c&oacute; sẵn&rdquo; cho kh&aacute;ch h&agrave;ng sử dụng. Kh&aacute;ch h&agrave;ng
                    sẽ chịu to&agrave;n bộ tr&aacute;ch nhiệm trong việc x&aacute;c định xem sản phẩm/dịch vụ hoặc
                    th&ocirc;ng tin được tạo ra từ sản phẩm /dịch vụ l&agrave; đ&uacute;ng đắn v&agrave; đ&aacute;p ứng
                    đầy đủ cho nhu cầu mục đ&iacute;ch sử dụng của kh&aacute;ch h&agrave;ng</li>
                  <li>Trong bất cứ trường hợp n&agrave;o của 1VIETNAM đều kh&ocirc;ng chịu tr&aacute;ch nhiệm về bất kỳ
                    c&aacute;c thiệt hại n&agrave;o trực tiếp, gi&aacute;n tiếp, ngẫu nhi&ecirc;n, đặc biệt, hậu quả
                    hoặc mang t&iacute;nh chất trừng phạt, bao gồm nhưng kh&ocirc;ng giới hạn c&aacute;c thiệt hại do
                    mất doanh thu, lợi nhuận, lợi thế kinh doanh, ngừng việc, mất m&aacute;t dữ liệu do hậu quả của:
                  </li>
                  <li>Việc sử dụng hoặc kh&ocirc;ng thể sử dụng sản phẩm/dịch vụ</li>
                  <li>Bất kỳ c&aacute;c thay đổi n&agrave;o được thực hiện đối với sản phẩm/dịch vụ</li>
                  <li>Truy cập kh&ocirc;ng được ph&eacute;p hoặc biến đổi c&aacute;c dữ liệu</li>
                  <li>Xo&aacute;, sai hỏng, hoặc h&agrave;nh vi của bất kỳ b&ecirc;n thứ ba n&agrave;o đối với sản
                    phẩm/dịch vụ</li>
                  <li>Bất kỳ vấn đề n&agrave;o kh&aacute;c li&ecirc;n quan đến sản phẩm/dịch vụ</li>
                  <li>Trong trường hợp c&aacute;c sản phẩm của 1VIETNAM c&oacute; sử dụng dịch vụ của b&ecirc;n thứ ba
                    như th&ocirc;ng tin tỉ gi&aacute;, chứng kho&aacute;n, thanh to&aacute;n,&hellip;, 1VIETNAM cam kết
                    kh&ocirc;ng t&iacute;nh ph&iacute; nhưng kh&ocirc;ng đảm bảo về t&iacute;nh đ&uacute;ng sai của
                    c&aacute;c th&ocirc;ng tin trong c&aacute;c ứng dụng/dịch vụ hoặc nếu b&ecirc;n thứ ba c&oacute; cập
                    nhật hệ thống m&agrave; dẫn đến mất sự ổn định ngưng trệ dịch vụ. V&igrave; vậy, người d&ugrave;ng
                    phải tự c&acirc;n nhắc khi sử dụng c&aacute;c dịch vụ n&agrave;y</li>
                  <li>1VIETNAM được miễn tr&aacute;ch nhiệm thực hiện nghĩa vụ được n&ecirc;u trong thoả thuận
                    n&agrave;y đối với c&aacute;c trường hợp bất khả kh&aacute;ng ghi trong thoả thuận n&agrave;y</li>
                </ol>

                <p><strong>Điều 14: Tr&aacute;ch nhiệm xử l&yacute; sự cố an ninh</strong></p>

                <ol>
                  <li>Trong trường hợp kh&aacute;ch h&agrave;ng ph&aacute;t hiện ra c&aacute;c sự cố an ninh của phần
                    mềm 1VIETNAM, kh&aacute;ch h&agrave;ng c&oacute; tr&aacute;ch nhiệm th&ocirc;ng b&aacute;o ngay với
                    1VIETNAM bằng c&aacute;ch ấn n&uacute;t phản hồi ngay tr&ecirc;n giao diện sản phẩm hoặc gọi đến
                    hotline của 1VIETNAM. C&aacute;c sự cố an ninh phần mềm bao gồm nhưng kh&ocirc;ng giới hạn
                    c&aacute;c trường hợp sau:</li>
                  <li>Bị mất hoặc thay đổi dữ liệu tr&ecirc;n phần mềm m&agrave; kh&ocirc;ng biết nguy&ecirc;n
                    nh&acirc;n</li>
                  <li>Bị gi&aacute;n đoạn kh&ocirc;ng sử dụng được sản phẩm</li>
                  <li>Nghi ngờ bị hacker tấn c&ocirc;ng</li>
                  <li>Khi xảy ra sự cố an ninh th&ocirc;ng tin li&ecirc;n quan đến sản phẩm 1VIETNAM cung cấp cho
                    kh&aacute;ch h&agrave;ng, 1VIETNAM sẽ c&oacute; tr&aacute;ch nhiệm tổ chức điều tra để xử l&yacute;
                    sự cố v&agrave; kh&ocirc;i phục hoạt động cho kh&aacute;ch h&agrave;ng. Trong qu&aacute;
                    tr&igrave;nh điều tra v&agrave; khắc phục sự cố, kh&aacute;ch h&agrave;ng c&oacute; tr&aacute;ch
                    nhiệm tham gia nếu 1VIETNAM y&ecirc;u cầu</li>
                </ol>

                <p><strong>Điều 15: Trường hợp bất khả kh&aacute;ng</strong></p>

                <p>Trong trường hợp bất khả kh&aacute;ng hai b&ecirc;n kh&ocirc;ng c&oacute; nghĩa vụ phải thực hiện
                  tr&aacute;ch nhiệm của m&igrave;nh trong thoả thuận n&agrave;y. Hai b&ecirc;n nhất tr&iacute; coi
                  c&aacute;c trường hợp sau l&agrave; bất khả kh&aacute;ng:</p>

                <ol>
                  <li>Thi&ecirc;n tai, địch hoạ g&acirc;y c&aacute;ch trở hoặc ph&aacute; huỷ hoặc tắc nghẽn hoặc dừng
                    kết nối với đến trung t&acirc;m dữ liệu của 1VIETNAM</li>
                  <li>Sự cố mất điện tr&ecirc;n diện rộng; Sự cố đứt c&aacute;p viễn th&ocirc;ng g&acirc;y tắc nghẽn
                    hoặc ngừng kết nối viễn th&ocirc;ng, Internet đến trung t&acirc;m dữ liệu của 1VIETNAM</li>
                  <li>Tin tặc (hacker), vi r&uacute;t m&aacute;y t&iacute;nh (virus) tấn c&ocirc;ng v&agrave;o trung
                    t&acirc;m dữ liệu của 1VIETNAM l&agrave;m ngưng trệ, tắc nghẽn hoặc ph&aacute; huỷ phần mềm
                    v&agrave; dữ liệu</li>
                  <li>C&aacute;c sự cố bất khả kh&aacute;ng kh&aacute;c theo quy định của ph&aacute;p luật</li>
                </ol>

                <p><strong>Điều 16: Tạm ngưng v&agrave; chấm dứt thoả thuận</strong></p>

                <ol>
                  <li>Trong thoả thuận n&agrave;y bắt đầu kể từ ng&agrave;y kh&aacute;ch h&agrave;ng đồng &yacute;
                    v&agrave; chấm dứt khi tất cả c&aacute;c thu&ecirc; bao được cấp k&egrave;m theo thoả thuận
                    n&agrave;y hết hạn sử dụng. Đối với trường hợp kh&aacute;ch h&agrave;ng d&ugrave;ng thử sản
                    phẩm/dịch vụ m&agrave; kh&ocirc;ng chuyển sang h&igrave;nh thức thu&ecirc; bao trước khi hết hạn
                    d&ugrave;ng thử, thoả thuận n&agrave;y sẽ được chấm dứt khi hết hạn d&ugrave;ng thử</li>
                  <li>1VIETNAM c&oacute; quyền tạm ngưng việc sử dụng của kh&aacute;ch h&agrave;ng đối với dịch vụ trong
                    c&aacute;c trường hợp sau:</li>
                  <li>Kh&aacute;ch h&agrave;ng kh&ocirc;ng thực hiện đăng k&yacute; gia hạn v&agrave; thanh to&aacute;n
                    c&aacute;c khoản ph&iacute; sử dụng sản phẩm/dịch vụ sau khi qu&aacute; hạn 30 ng&agrave;y</li>
                  <li>1VIETNAM cho rằng dịch vụ đang được kh&aacute;ch h&agrave;ng sử dụng để tham gia v&agrave;o
                    c&aacute;c cuộc tấn c&ocirc;ng từ chối dịch vụ, gửi thư r&aacute;c, c&aacute;c hoạt động bất hợp
                    ph&aacute;p hoặc sử dụng sản phẩm/dịch vụ của kh&aacute;ch h&agrave;ng g&acirc;y nguy hại tới
                    1VIETNAM v&agrave; những người kh&aacute;c</li>
                  <li>Thoả thuận được coi như chấm dứt trong c&aacute;c trường hợp sau:</li>
                  <li>1VIETNAM đơn phương chấm dứt thoả thuận do kh&aacute;ch h&agrave;ng kh&ocirc;ng thực hiện nghĩa vụ
                    thanh to&aacute;n cho 1VIETNAM theo thoả thuận giữa hai b&ecirc;n</li>
                  <li>1VIETNAM đơn phương chấm dứt thoả thuận theo y&ecirc;u cầu của to&agrave; &aacute;n v&agrave; cơ
                    quan c&oacute; thẩm quyền của nh&agrave; nước</li>
                  <li>Kh&aacute;ch h&agrave;ng gửi th&ocirc;ng b&aacute;o y&ecirc;u cầu chấm dứt thoả thuận thu&ecirc;
                    bao cho 1VIETNAM bằng văn bản</li>
                  <li>1VIETNAM kh&ocirc;ng c&oacute; nghĩa vụ ho&agrave;n trả bất kỳ chi ph&iacute; n&agrave;o m&agrave;
                    kh&aacute;ch h&agrave;ng đ&atilde; thanh to&aacute;n trong trường hợp chấm dứt thoả thuận v&igrave;
                    những l&yacute; do đ&atilde; n&ecirc;u tr&ecirc;n. 1VIETNAM chỉ chịu tr&aacute;ch nhiệm đảm bảo duy
                    tr&igrave; dữ liệu của kh&aacute;ch h&agrave;ng tr&ecirc;n hệ thống tối đa l&agrave; 30 ng&agrave;y
                    kể từ ng&agrave;y chấm dứt thoả thuận</li>
                </ol>

                <p><strong>Điều 17: Điều khoản sửa đổi, bổ sung thoả thuận</strong></p>

                <ol>
                  <li>1VIETNAM c&oacute; quyền sửa đổi, bổ sung c&aacute;c điều khoản trong thoả thuận sử dụng dịch vụ
                    được c&ocirc;ng bố tr&ecirc;n website&nbsp;<a href="http://oliu.io/">http://oliu.io</a> v&agrave;
                    tr&ecirc;n phần mềm</li>
                  <li>Trường hợp kh&aacute;ch h&agrave;ng kh&ocirc;ng đồng &yacute; với c&aacute;c điều khoản sửa đổi,
                    bổ sung đ&oacute;, kh&aacute;ch h&agrave;ng c&oacute; thể ngừng sử dụng phần mềm</li>
                </ol>

                <p><strong>Điều 18: Căn cứ ph&aacute;p l&yacute;</strong></p>

                <p>Thoả thuận n&agrave;y được soạn thảo căn cứ v&agrave;o:</p>

                <ol>
                  <li>Bộ luật D&acirc;n sự số 91/2015/QH13 ng&agrave;y 24/11/2015</li>
                  <li>Luật Thương mại số 36/2005/QH11 ng&agrave;y 14/06/2005</li>
                  <li>Luật C&ocirc;ng nghệ th&ocirc;ng tin số 67/2006/QH11 ng&agrave;y 29/06/2006</li>
                </ol>

                <p><strong>Điều 19: Điều khoản chung</strong></p>

                <ol>
                  <li>Trong qu&aacute; tr&igrave;nh thực hiện thoả thuận nếu c&oacute; vấn đề g&igrave; nảy sinh
                    th&igrave; hai b&ecirc;n sẽ c&ugrave;ng b&agrave;n bạc, thống nhất v&agrave; t&igrave;m giải
                    ph&aacute;p khắc phục</li>
                  <li>Trong trường hợp nảy sinh tranh chấp m&agrave; hai b&ecirc;n kh&ocirc;ng thể c&ugrave;ng nhau
                    thương lượng giải quyết được th&igrave; hai b&ecirc;n c&ugrave;ng thống nhất mang ra To&agrave;
                    &aacute;n c&oacute; thẩm quyền tr&ecirc;n địa b&agrave;n Th&agrave;nh phố H&agrave; Nội để giải
                    quyết.</li>
                </ol>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="copyright-text">
        <p>Copyright @2020 Oliu. All Rights Reserved <a href="http://oliu.io/" target="_blank">Oliu.io</a></p>
      </div>
    </div>
  </footer>
  <!-- End Footer Area -->

  <!-- Go Top -->
  <div class="go-top">
    <i class="las la-angle-double-up"></i>
  </div>
  <!-- End Go Top -->
